const messages = {
  pt: {
    translations: {
      signup: {
        title: "Cadastre-se",
        toasts: {
          success: "Usuário criado com sucesso! Faça seu login!!!.",
          fail: "Erro ao criar usuário. Verifique os dados informados.",
          userCreationDisabled: "Cadastro de novos usuários está desabilitado.",
          verificationError: "Erro ao verificar permissão de cadastro.",
        },
        form: {
          name: "Nome",
          email: "Email",
          password: "Senha",
          company: "Nome da Organização",
          phone: "WhatsApp (Código do país + número)",
          phonePlaceholder: "+55 (00) 00000-0000",
          plan: "Plano",
          planDetails: {
            attendants: "Atendentes",
            whatsapp: "WhatsApp",
            queues: "Filas",
            currency: "R$",
          },
        },
        buttons: {
          submit: "Cadastrar",
          login: "Já tem uma conta? Entre!",
        },
      },
      validation: {
        tooShort: "Muito curto!",
        tooLong: "Muito longo!",
        required: "Obrigatório",
        invalidEmail: "Email inválido",
      },
      schedulesForm: {
        keepFlowsOutOfHours: {
          title: "Manter fluxos ativos fora do horário",
          description: "Quando ligado, chatbots e fluxos do FlowBuilder continuam respondendo mesmo fora do horário de atendimento. A mensagem de ausência abaixo não é enviada nesse modo.",
        },
        outOfHoursMessage: {
          title: "Mensagem de ausência",
          description: "Enviada automaticamente ao cliente quando ele entra em contato fora do horário de atendimento.",
          placeholder: "Ex.: Olá! Estamos fora do horário de atendimento. Retornaremos em breve.",
        },
        helps: {
          keepFlowsOutOfHours: {
            description: "Define o que acontece quando alguém manda mensagem fora do horário configurado abaixo.",
            steps: [
              "Desligado (padrão): bots e fluxos ficam pausados; o cliente recebe a mensagem de ausência (se configurada).",
              "Ligado: bots e FlowBuilder continuam atendendo normalmente, sem enviar mensagem de ausência.",
              "Use ligado quando seus fluxos já lidam com 24/7 (autoatendimento, FAQ, IA).",
              "Mantenha desligado se há atendentes humanos no fluxo que ficam offline.",
            ],
          },
          outOfHoursMessage: {
            description: "Texto enviado uma vez por ticket quando o cliente escreve fora do horário.",
            steps: [
              "Ligue o toggle e digite a mensagem que será enviada automaticamente.",
              "É enviada apenas uma vez por ticket — o cliente não recebe spam se mandar várias mensagens.",
              "Funciona em conjunto com o horário definido em \"Geral › Programação de Horário de Trabalho\".",
              "Não é enviada se \"Manter fluxos ativos fora do horário\" estiver ligado.",
            ],
          },
        },
        bulk: {
          fillWeekdays: "Dias úteis 09:00–18:00",
          fillWeekdaysHelp: "Preenche segunda a sexta com 09:00–12:00 e 13:00–18:00",
          closeWeekend: "Fim de semana fechado",
          closeWeekendHelp: "Limpa sábado e domingo",
          copyFirst: "Copiar do primeiro dia",
          copyFirstHelp: "Aplica os horários da segunda-feira aos demais dias",
          clearAll: "Limpar tudo",
          clearAllHelp: "Remove todos os horários",
        },
        morning: "Manhã",
        afternoon: "Tarde",
        start: "Início",
        end: "Fim",
        dayClosed: "Fechado nesse dia",
      },
      login: {
        title: "Login",
        logoAlt: "Logo",
        emailLabel: "Email",
        passwordLabel: "Senha",
        rememberMe: "Lembrar de mim",
        loginButton: "Entrar",
        signupButton: "Cadastre-se",
        noAccount: "Não tem uma conta?",
        forgotPassword: "Esqueceu a senha?",
        secureArea: "Área segura",
        emailPlaceholder: "voce@exemplo.com",
        togglePassword: "Mostrar/ocultar senha",
        or: "ou",
        whatsappLabel: "Fale conosco no WhatsApp",
        whatsappTitle: "Fale conosco no WhatsApp",
        form: {
          email: "Email",
          password: "Senha",
          button: "Acessar",
        },
        buttons: {
          submit: "Entrar",
          register: "Não tem um conta? Cadastre-se!",
        },
      },
      companies: {
        title: "Empresas",
        form: {
          name: "Nome da Empresa",
          plan: "Plano",
          token: "Token",
          submit: "Cadastrar",
          success: "Empresa criada com sucesso!",
        },
      },
      auth: {
        toasts: {
          success: "Login efetuado com sucesso!",
        },
        dueDate: {
          expiration: "Sua assinatura expira em",
          days: "dias!",
          day: "dia!",
          expirationToday: "Sua assinatura expira hoje!",
        },
        token: "Token",
      },
      forgotPassword: {
        title: "Redefinir Senha",
        form: {
          emailLabel: "Digite seu e-mail",
          submitButton: "Enviar Link de Redefinição",
          backToLogin: "Voltar ao Login",
        },
        loading: {
          sending: "Enviando...",
          sent: "Enviado!",
        },
        toasts: {
          success: "Link de redefinição de senha enviado com sucesso",
        },
      },
      resetPassword: {
        title: "Redefinir Senha",
        form: {
          newPassword: "Nova Senha",
          confirmPassword: "Confirmar Senha",
        },
        buttons: {
          submit: "Redefinir Senha",
          submitting: "Redefinindo...",
          submitted: "Redefinido!",
          backToLogin: "Voltar ao Login",
        },
        errors: {
          passwordMismatch: "As senhas não coincidem",
          passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
          invalidToken: "Token de redefinição ausente ou inválido. Por favor, solicite um novo link de redefinição.",
          resetError: "Erro ao redefinir senha. Tente novamente.",
        },
        toasts: {
          success: "Senha redefinida com sucesso",
          passwordMismatch: "As senhas não coincidem",
          passwordTooShort: "A senha deve ter pelo menos 6 caracteres",
        },
      },
      financeiro: {
        title: "Financeiro",
        subtitle: "Acompanhe o status das empresas, planos e cobranças em um só lugar.",
        table: {
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queues: "Filas",
          value: "Valor mensal",
          dueDate: "Vencimento",
          status: "Status",
          action: "Ação",
          company: "Empresa",
          plan: "Plano"
        },
        stats: {
          total: "Empresas",
          totalHint: "Cadastradas no sistema",
          revenue: "Receita ativa",
          revenueHint: "Recorrência mensal estimada",
          overdue: "Em atraso",
          overdueHint: "Pagamentos pendentes",
          trial: "Em trial",
          trialHint: "Sem pagamento ainda"
        },
        filters: {
          search: "Buscar por nome ou e-mail...",
          status: "Status",
          all: "Todos os status"
        },
        statusList: {
          active: "Em dia",
          overdue: "Atrasado",
          trial: "Trial",
          pending: "Pendente",
          inactive: "Inativa"
        },
        empty: {
          list: "Nenhuma empresa cadastrada.",
          filtered: "Nenhuma empresa encontrada com esses filtros."
        },
        tooltips: {
          details: "Detalhes da fatura",
          users: "Número de usuários",
          connections: "Número de conexões",
          queues: "Número de filas",
          value: "Valor da fatura",
          dueDate: "Data de vencimento"
        },
        status: {
          paid: "Pago",
          overdue: "Vencido",
          open: "Em Aberto",
          yes: "Sim",
          no: "Não",
          overdueFor: "Vencido há {{days}} dias",
          dueToday: "Vence hoje",
          dueIn: "Vence em {{days}} dias"
        },
        buttons: {
          pay: "PAGAR",
          paid: "PAGO",
          payNow: "PAGAR AGORA",
          charge: "Cobrar",
          chargeClient: "Cobrar cliente",
          inactive: "Inativa"
        },
        charge: {
          title: "Cobrar cliente",
          phone: "Telefone",
          email: "E-mail",
          messageLabel: "Mensagem",
          whatsapp: "Enviar WhatsApp",
          emailBtn: "Enviar e-mail",
          emailSubject: "Pendência financeira",
          openLink: "Abrir link da fatura",
          copy: "Copiar mensagem",
          copied: "Mensagem copiada!",
          copyError: "Não foi possível copiar.",
          noPhone: "Empresa sem telefone cadastrado.",
          noEmail: "Empresa sem e-mail cadastrado.",
          noLink: "Fatura sem link de pagamento."
        },
        checkout: {
          title: "Falta pouco!",
          steps: {
            data: "Dados",
            customize: "Personalizar",
            review: "Revisar"
          },
          messages: {
            notFound: "Not Found",
            paymentNotice: "Ao realizar o pagamento, atualize a página!",
            subscriptionSuccess: "Assinatura realizada com sucesso!, aguardando a realização do pagamento"
          },
          buttons: {
            back: "VOLTAR",
            pay: "PAGAR",
            next: "PRÓXIMO"
          },
          pricing: {
            users: "Usuários",
            connection: "Conexão",
            queues: "Filas",
            select: "SELECIONAR",
            perMonth: "/mês"
          },
          review: {
            title: "Resumo da assinatura"
          },
          success: {
            total: "TOTAL",
            copied: "Copiado",
            copyQr: "Copiar código QR",
            finalizeMessage: "Para finalizar, basta realizar o pagamento escaneando ou colando o código Pix acima :)",
            licenseRenewed: "Sua licença foi renovada até"
          },
          planDetails: {
            title: "Detalhes do plano",
            billing: "Cobrança: Mensal"
          },
          paymentInfo: {
            title: "Informação de pagamento",
            email: "Email:",
            name: "Nome:",
            document: "CPF/CNPJ:",
            total: "Total:"
          }
        }
      },
      dashboard: {
        title: "Dashboard",
        subtitle: "Visão geral do seu atendimento em tempo real",
        buttons: {
          filter: "Filtrar",
          export: "Exportar"
        },
        tabs: {
          indicators: "Indicadores",
          assessments: "NPS",
          attendants: "Atendentes",
          performance: "Performances"
        },
        charts: {
          performance: "Gráficos",
          userPerformance: "Gráfico dos Usuários",
          hourlyServices: "Atendimentos por hora",
          ticketsLabel: "Tickets",
          score: "Pontuação",
          perDay: {
            title: "Atendimentos hoje: ",
          },
          errorFetchingTickets: "Erro ao buscar informações dos tickets",
          noDataAvailable: "Nenhum dado disponível para o período selecionado.",
          avgPerDay: "Média/dia",
          peak: "Pico",
          totalAgents: "Atendentes",
          topAgent: "Destaque",
          day: "dia",
          days: "dias",
          presets: {
            today: "Hoje",
            month: "Mês"
          },
        },
        cards: {
          inAttendance: "Em Atendimento",
          waiting: "Aguardando",
          activeAttendants: "Atendentes Ativos",
          finalized: "Finalizados",
          newContacts: "Novos Contatos",
          totalReceivedMessages: "Mensagens Recebidas",
          totalSentMessages: "Mensagens Enviadas",
          averageServiceTime: "T.M. de Atendimento",
          averageWaitingTime: "T.M. de Espera",
          status: "Status (Atual)",
          activeTickets: "Tickets Ativos",
          passiveTickets: "Tickets Passivos",
          groups: "Grupos",
        },
        users: {
          name: "Nome",
          numberAppointments: "Quantidade de Atendimentos",
          statusNow: "Atual",
          totalCallsUser: "Total de atendimentos por usuário",
          totalAttendances: "Total de atendimentos",
          totalLabel: "Total de atendimentos: {{count}}",
          queues: "Filas",
          defaultQueue: "Conexão Padrão",
          workingHours: "Horário de trabalho",
          startWork: "Início de trabalho",
          endWork: "Fim de trabalho",
          farewellMessage: "Mensagem de despedida",
          theme: "Tema Padrão",
          menu: "Menu padrão"
        },
        date: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        licence: {
          available: "Disponível até",
        },
        assessments: {
          totalCalls: "Total de Atendimentos",
          callsWaitRating: "Atendimentos aguardando avaliação",
          callsWithoutRating: "Atendimentos sem avaliação",
          ratedCalls: "Atendimentos avaliados",
          evaluationIndex: "Índice de avaliação",
          score: "Pontuação",
          prosecutors: "Promotores",
          neutral: "Neutros",
          detractors: "Detratores",
          generalScore: "NPS Score Geral",
        },
        status: {
          online: "Online",
          offline: "Offline",
        },
        filters: {
          title: "Filtros",
          initialDate: "Inicial",
          finalDate: "Final",
          filterButton: "Filtrar",
        },
        errors: {
          loadData: "Não foi possível carregar os dados do dashboard.",
          exportExcel: "Erro ao exportar para Excel.",
        },
        export: {
          sheetName: "RelatorioDeAtendentes",
          fileName: "relatorio-de-atendentes.xlsx",
        },
        nps: {
          overallScore: "NPS Score Geral",
        },
      },
      reports: {
        title: "Relatórios de Atendimentos",
        subtitle: "Histórico completo de atendimentos com filtros e exportação",
        kpis: {
          total: "Total de tickets",
          open: "Em aberto",
          closed: "Finalizados",
          rated: "Avaliados",
        },
        table: {
          id: "ID",
          whatsapp: "Conexão",
          contact: "Contato",
          user: "Atendente",
          queue: "Fila",
          status: "Status",
          lastMessage: "Última mensagem",
          dateOpen: "Aberto em",
          dateClose: "Fechado em",
          supportTime: "Tempo de atendimento",
          NPS: "NPS",
          actions: "Ações",
          empty: "Nenhum atendimento encontrado para os filtros aplicados.",
        },
        buttons: {
          filter: "Filtrar",
          onlyRated: "Apenas avaliados",
          export: "Exportar",
          clear: "Limpar filtros",
        },
        filters: "Filtros",
        contactSearch: "Buscar contato...",
        contactSearchHint: "Digite ao menos 2 letras",
        operator: "Operador",
        period: "Período",
        until: "Até",
        date: "Data",
        reportTitle: "Relatórios",
        calls: "Atendimentos",
        search: "Pesquisas",
        durationCalls: "Duracão dos atendimentos",
        grupoSessions: "Atendimentos em grupos",
        groupTicketsReports: {
          timezone: "America/Sao_Paulo",
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          errorToast: "Erro ao gerar o relatório",
          back: "Voltar",
          groupServiceReport: "Relatório de Atendimento em Grupos",
          loading: "Carregando...",
          contact: "Contato",
          dateOpen: "Data abertura",
          dateLastUpdated: "Data Última Atualização",
          agent: "Quem atendeu",
          agentClosed: "Quem fechou",
          waitingAssistance: "Aguardando atendimento",
          process: "Em atendimento",
        },
        researchReports: {
          response: "resposta",
          active: "(Ativa)",
          inactive: "(Inativa)",
          quantity: "Quantidade",
          percentage: "porcentagem",
          title: "Relatório de Pesquisas Realizadas",
          activeSearch: "Pesquisa ativa",
          inactiveSearch: "Pesquisa inativa",
        },
        ticketDurationDetail: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Duração do Atendimento",
          startService: "Início do atendimento",
          lastUpdated: "Última atualização",
          lastAgent: "Último atendente",
          durationFinished: "Duração após finalizado",
        },
        ticketDuration: {
          title: "Relatório de Duração dos Atendimento",
          contact: "Contato",
          open: "Abertos",
          pending: "Pendentes",
          finished: "Finalizados",
          durationFinished: "Duração dos finalizados",
          durationAfterFinished: "Duração após finalizado",
          actions: "Ações",
        },
        ticketReports: {
          msgToast: "Gerando relatório compactado, por favor aguarde.",
          title: "Relatório de Atendimento",
        },
        pdf: {
          title: "Relação de Atendimentos Realizados",
          exportTitle: "Relação de Atendimentos em Grupos Realizados",
        },
        form: {
          initialDate: "Data Inicial",
          finalDate: "Data Final",
        },
        excel: {
          connection: "Conexão",
          contact: "Contato",
          user: "Usuário",
          queue: "Fila",
          status: "Status",
          lastMessage: "ÚltimaMensagem",
          dateOpen: "DataAbertura",
          timeOpen: "HoraAbertura",
          dateClose: "DataFechamento",
          timeClose: "HoraFechamento",
          supportTime: "TempoDeAtendimento",
          nps: "nps",
          fileName: "relatorio-de-atendimentos.xlsx",
          sheetName: "RelatorioDeAtendimentos",
        },
        tooltips: {
          ticketLogs: "Logs do Ticket",
          accessTicket: "Acessar Ticket",
          exportExcel: "Exportar para Excel",
        },
      },
      todo: {
        newTask: "Nova Tarefa",
        add: "Adicionar",
        save: "Salvar",
        task: "Tarefas",
      },
      allConnections: {
        errors: {
          loadCompanies: "Não foi possível carregar a lista de registros",
          unknownChannel: "error"
        },
        subtitle: "Conecte seus canais de atendimento para receber mensagens e iniciar conversas com seus clientes.",
        channels: {
          whatsapp: "WhatsApp",
          facebook: "Facebook",
          instagram: "Instagram"
        },
        table: {
          client: "Cliente",
          connectedConnections: "Conexões conectadas",
          disconnectedConnections: "Conexões Desconectadas",
          totalConnections: "Total de Conexões",
          total: "Total"
        }
      },
      companyWhatsapps: {
        title: "Conexões de: {{companyName}}",
        table: {
          channel: "Canal"
        }
      },
      channels: {
        whatsapp: "WhatsApp",
        whatsappOfficial: "WhatsApp API Oficial",
        facebook: "Facebook",
        instagram: "Instagram"
      },
      connections: {
        title: "Conexões",
        subtitle: "Gerencie seus canais de atendimento (WhatsApp, Facebook, Instagram)",
        waitConnection: "Aguarde... Suas conexões serão reiniciadas!",
        newConnection: "Nova Conexão",
        restartConnections: "Reiniciar Conexões",
        callSupport: "Chamar Suporte",
        toasts: {
          deleted: "Conexão excluída com sucesso!",
          closedimported:
            "Estamos fechando os tickets importados, por favor aguarde uns instantes",
          officialApiSoon: "Integração com a API Oficial em breve!",
        },
        confirmationModal: {
          closedImportedTitle: "Fechar tickets importados",
          closedImportedMessage:
            "Se você confirmar todos os tickets importados serão fechados",
          deleteTitle: "Deletar",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida.",
          disconnectTitle: "Desconectar",
          disconnectMessage:
            "Tem certeza? Você precisará ler o QR Code novamente.",
        },
        buttons: {
          add: "Adicionar Conexão",
          disconnect: "Desconectar",
          tryAgain: "Tentar novamente",
          reconnect: "Reconectar",
          qrcode: "QR CODE",
          newQr: "Novo QR CODE",
          closedImported: "Fechar todos os tickets Importados",
          preparing: "Preparando mensagens para importação",
          importing: "Importando Mensagens do WhatsApp",
          processed: "Processado",
          in: "de",
          connecting: "Conectando",
          edit: "Editar",
          delete: "Excluir",
        },
        empty: "Nenhuma conexão cadastrada.",
        status: {
          connected: "Conectado",
          disconnected: "Desconectado",
          syncError: "Falha de sincronização",
          stale: "Sem resposta",
          qrcode: "QR Code",
          pairing: "Pareando",
          timeout: "Timeout",
          comingSoon: "Em breve",
        },
        typography: {
          processed: "Processado",
          in: "de",
          date: "Data da mensagem",
        },
        toolTips: {
          disconnected: {
            title: "Falha ao iniciar sessão do WhatsApp",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e tente novamente, ou solicite um novo QR Code",
          },
          qrcode: {
            title: "Esperando leitura do QR Code",
            content:
              "Clique no botão 'QR CODE' e leia o QR Code com o seu celular para iniciar a sessão",
          },
          connected: {
            title: "Conexão estabelecida!",
          },
          timeout: {
            title: "A conexão com o celular foi perdida",
            content:
              "Certifique-se de que seu celular esteja conectado à internet e o WhatsApp esteja aberto, ou clique no botão 'Desconectar' para obter um novo QR Code",
          },
          syncError: {
            title: "Falha ao processar mensagens",
            content:
              "A sessão está conectada, mas o sistema falhou ao gravar dados da conexão. Reinicie a conexão e verifique novamente.",
          },
          stale: {
            title: "Conexão sem resposta",
            content:
              "O WhatsApp segue logado, mas não recebe mensagens há um tempo. Clique em \"Reconectar\" para forçar reconexão (sem novo QR).",
          },
        },
        table: {
          name: "Nome",
          status: "Status",
          lastUpdate: "Última atualização",
          default: "Padrão",
          actions: "Ações",
          session: "Sessão",
          number: "Número do WhatsApp",
          channel: "Canal",
        },
        iconChannel: {
          error: "Erro",
        },
        facebook: {
          success: "Página conectada com sucesso!",
        },
      },
      facebookModal: {
        title: "Conectar {{channel}}",
        description: "Siga os passos abaixo para conectar o {{channel}} ao sistema de atendimento.",
        steps: {
          step1: {
            title: "Criar um App no Meta for Developers",
            description: "Acesse developers.facebook.com, clique em \"Criar App\", selecione o tipo \"Negócios\" e preencha o nome do app.",
          },
          step1b: {
            title: "Configurar Produtos no App",
            description: "No painel do App, vá em \"Adicionar Produto\" e adicione o \"Messenger\". Para Instagram, adicione também o \"Instagram\".",
          },
          step1c: {
            title: "Configurar URLs de Política e Termos",
            description: "No painel do App, vá em \"Configurações > Básico\". Preencha os campos obrigatórios:",
            privacyUrl: "URL da Política de Privacidade:",
            termsUrl: "URL dos Termos de Uso:",
            copied: "Copiado!",
          },
          step2: {
            title: "Ter uma Página do Facebook",
            description: "Você precisa ser administrador de uma Página do Facebook. O Messenger será conectado a essa página.",
          },
          step3instagram: {
            title: "Conta Instagram Business vinculada à Página",
            description: "Para receber mensagens do Instagram, sua conta Instagram precisa ser do tipo Business ou Profissional e estar vinculada à sua Página do Facebook.",
          },
          stepConnect: {
            title: "Autorizar a conexão",
            description: "Clique no botão abaixo para fazer login com sua conta do Facebook e autorizar o {{channel}} a receber e enviar mensagens pelo sistema.",
          },
        },
        permissions: {
          title: "Permissões solicitadas:",
          sendReceive: "Enviar e receber mensagens pela página",
          pagesList: "Listar suas páginas do Facebook",
          managePages: "Gerenciar metadata das páginas",
          instagramMessages: "Enviar e receber mensagens do Instagram Direct",
        },
        warning: {
          title: "Importante:",
          facebook: "Após a autorização, todas as páginas vinculadas à sua conta serão conectadas automaticamente.",
          instagram: "Sua conta Instagram precisa ser Business/Profissional e estar vinculada a uma Página do Facebook. Após a autorização, o Instagram será conectado automaticamente.",
        },
        buttons: {
          cancel: "Cancelar",
          connect: "Conectar {{channel}}",
          connecting: "Conectando...",
        },
        errors: {
          noAppIdTitle: "Configuração pendente!",
          noAppId: "Para conectar o Facebook/Instagram é necessário configurar o App ID do Meta. Acesse o Meta for Developers, crie um App e configure a variável REACT_APP_FACEBOOK_APP_ID no sistema.",
        },
        success: {
          facebook: "Facebook Messenger conectado com sucesso!",
          instagram: "Instagram Direct conectado com sucesso!",
        },
      },
      showTicketOpenModal: {
        title: {
          header: "Atendimento Existente",
        },
        form: {
          message: "Este contato já está em atendimento:",
          user: "Atendente",
          queue: "Fila",
          messageWait:
            "Este contato já está aguardando atendimento. Veja na aba Aguardando!",
        },
      },
      showTicketLogModal: {
        title: {
          header: "Histórico do ticket",
        },
        options: {
          create: "Ticket criado.",
          chatBot: "ChatBot iniciado.",
          queue: " - Fila definida.",
          open: " iniciou o atendimento.",
          access: "acessou o ticket.",
          transfered: "transferiu o ticket.",
          receivedTransfer: "recebeu o ticket transferido.",
          pending: "devolveu para a fila.",
          closed: "fechou o ticket.",
          reopen: "reabriu o ticket.",
          redirect: " - redirecionado."
        },
        close: "Fechar",
        empty: "Ainda não há registros para este ticket.",
      },
      statusFilter: {
        title: "Filtro por Status",
        groups: "Grupos",
        selected: "selecionados",
      },
      whatsappModal: {
        title: {
          add: "Adicionar Conexão",
          edit: "Editar Conexão",
        },
        tabs: {
          general: "Geral",
          messages: "Mensagens",
          assessments: "NPS",
          integrations: "Integrações",
          schedules: "Horário de expediente",
          chatbot: "Chatbot",
          defaultFlow: "Fluxo Padrão",
        },
        form: {
          identitySectionTitle: "Identificação",
          behaviorSectionTitle: "Comportamento",
          tokenRefreshTooltip: "Gerar novo token",
          tokenCopyTooltip: "Copiar token",
          queueIdImportMessagesDesc: "Fila para a qual os tickets criados pela importação serão direcionados. Defina uma fila específica para isolar o histórico importado dos tickets ativos.",
          sendIdQueueDesc: "Fila padrão para receber tickets de contatos que ainda não estão atribuídos a nenhuma fila. Funciona como fallback automático.",
          timeSendQueueDesc: "Tempo (em minutos) que o sistema aguarda antes de mover o contato sem fila para a fila padrão acima. Use 0 para desativar o redirecionamento automático.",
          queuesSectionTitle: "Filas de atendimento",
          queuesSectionDesc: "Filas (departamentos) que receberão os tickets dessa conexão. Atendentes membros dessas filas terão acesso aos tickets.",
          queuesHelp: "Selecione uma ou mais filas. Toda mensagem que entrar por essa conexão fica disponível para os atendentes associados a essas filas. Se nenhuma fila for selecionada, somente administradores verão os tickets.",
          integrationSectionTitle: "Integração externa",
          integrationSectionDesc: "Use apenas quando quiser encaminhar essa conexão para um sistema externo, como Typebot, Dialogflow, n8n ou webhook customizado. O FlowBuilder nativo é configurado na aba Fluxo Padrão.",
          integrationHelp: "Quando uma integração externa é selecionada, as mensagens são processadas pelo sistema configurado em Configurações > Integrações. Para usar o FlowBuilder nativo da plataforma, deixe este campo desabilitado e selecione o fluxo na aba Fluxo Padrão.",
          integrationsInfoTitle: "ⓘ Integrações da conexão",
          integrationsInfoText: "Use esta aba somente para encaminhar mensagens da conexão para uma <strong>integração externa</strong>, como Typebot, n8n ou webhook. Para mandar contatos para uma fila, use o <strong>Redirecionamento de Fila</strong> na aba Geral. O FlowBuilder nativo fica na aba <strong>Fluxo Padrão</strong>.",
          npsInfoTitle: "ⓘ O que é NPS e como funciona aqui",
          npsInfoText: "<strong>NPS (Net Promoter Score)</strong> é uma pesquisa enviada ao cliente <strong>após o ticket ser encerrado</strong>, pedindo uma nota de <strong>0 a 10</strong> sobre a experiência.<ul><li>A pergunta é enviada automaticamente pelo bot do sistema.</li><li>A nota recebida fica armazenada e pode ser consultada nos relatórios.</li><li>Se o cliente não responder, o sistema reenvia até a quantidade máxima configurada.</li><li>Após o tempo limite, o ticket de avaliação é encerrado automaticamente.</li></ul><strong>Importante:</strong> para ativar o envio do NPS é necessário habilitar <em>Avaliação de usuário</em> em Configurações → Empresa.",
          npsSurveySectionTitle: "Pesquisa de avaliação",
          npsRulesSectionTitle: "Regras de envio",
          ratingMessageDesc: "Texto enviado ao cliente solicitando a nota. Use uma frase curta e amigável. A escala obrigatória é de 0 a 10. Ex: 'De 0 a 10, o quanto você recomendaria nosso atendimento?'",
          maxUseBotQueuesNPSDesc: "Número máximo de vezes que a pergunta de avaliação será reenviada caso o cliente não responda. Recomendado: 2 ou 3 tentativas.",
          expiresTicketNPSDesc: "Tempo (em minutos) que o sistema aguarda uma resposta antes de encerrar automaticamente o ticket de avaliação. Use 0 para nunca encerrar automaticamente.",
          imageLabel: "Imagem da conexão",
          imageDesc: "Foto/vídeo opcional usado para identificar visualmente esta conexão na sua lista de canais.",
          nameDesc: "Nome interno da conexão (visível só para sua equipe). Use algo descritivo como 'Suporte Comercial' ou 'Vendas BR'.",
          defaultDesc: "Quando ativada, esta passa a ser a conexão usada por padrão para envios automáticos (campanhas, integrações, API externa).",
          groupDesc: "Permite que mensagens de grupos do WhatsApp sejam recebidas e abram tickets na plataforma. Desativado por padrão para evitar ruído.",
          groupAsTicketDesc: "Define como mensagens de grupo serão tratadas: 'Habilitado' cria um ticket por grupo; 'Desabilitado' ignora ou agrupa as mensagens.",
          importSectionTitle: "Importação de mensagens",
          importSectionDesc: "Recupera o histórico recente de conversas do aparelho conectado. Configure com cuidado: a importação é limitada e pode impactar a performance.",
          importInfoTitle: "ⓘ Antes de ativar, leia com atenção",
          importInfoText: "A importação <strong>não traz todo o histórico</strong> do WhatsApp — somente as mensagens que ainda estão em cache no aparelho.<ul><li><strong>Limite real:</strong> em geral apenas as últimas semanas/meses são recuperáveis, dependendo do uso do aparelho.</li><li><strong>Conexão será encerrada</strong> ao salvar e você precisará ler o QR Code novamente.</li><li><strong>Pode demorar bastante</strong> e gerar carga no servidor enquanto roda.</li><li><strong>Recomendação:</strong> para começar limpo, prefira <strong>criar uma nova conexão</strong> sem importação e deixe o histórico se construir naturalmente.</li></ul>",
          importOldMessagesEnable: "Importar mensagens do aparelho",
          importOldMessagesEnableDesc: "Ativa a tentativa de importar as conversas em cache no celular ao conectar. Use somente se você realmente precisa de histórico anterior.",
          importOldMessages: "Data inicial da importação",
          importRecentMessages: "Data final da importação",
          importOldMessagesGroups: "Importar mensagens de grupos",
          importOldMessagesGroupsDesc: "Inclui o histórico das conversas em grupos no escopo da importação. Pode aumentar bastante o volume de tickets gerados.",
          closedTicketsPostImported: "Encerrar tickets após importação",
          closedTicketsPostImportedDesc: "Marca automaticamente como encerrados todos os tickets criados pela importação. Útil para não poluir a fila de atendentes.",
          name: "Nome",
          tokenSectionTitle: "Token para integração externa",
          tokenSectionDesc: "Use este token para autenticar requisições à API do sistema usando esta conexão como remetente. Mantenha em segredo.",
          queueRedirection: "Redirecionamento de Fila",
          queueRedirectionDesc:
            "Define para qual fila os contatos sem fila atribuída serão redirecionados automaticamente após o tempo configurado.",
          default: "Padrão",
          group: "Permitir grupos",
          timeSendQueue: "Tempo em minutos para redirecionar para fila",
          importAlert:
            "ATENÇÃO: ao salvar, a conexão será encerrada e você precisará ler o QR Code novamente. A importação puxa apenas o que estiver em cache no aparelho — não é o histórico completo do WhatsApp.",
          groupAsTicket: "Tratar grupos como ticket",
          timeCreateNewTicket: "Criar novo ticket em x minutos",
          maxUseBotQueues: "Enviar bot x vezes",
          timeUseBotQueues: "Enviar bot em x minutos",
          expiresTicket: "Encerrar chats abertos após x minutos",
          expiresTicketNPS:
            "Encerrar chats aguardando avaliação após x minutos",
          maxUseBotQueuesNPS:
            "Quantidade máxima de vezes que a avaliaçao vai ser enviada",
          closeLastMessageOptions1: "Do atendente/Cliente",
          closeLastMessageOptions2: "Do atendente",
          outOfHoursMessage: "Mensagem de fora de expediente",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          lgpdLinkPrivacy: "Link para política de privacidade",
          lgpdMessage: "Mensagem de saudaçao LGPD",
          lgpdDeletedMessages: "Ofuscar mensagem apagada pelo contato",
          lgpdSendMessage: "Sempre solicitar confirmação do contato",
          ratingMessage: "Mensagem de avaliaçao - Escala deve ser de 0 a 10",
          token: "Token para integração externa",
          sendIdQueue: "Fila",
          inactiveMessage: "Mensagem de inatividade",
          timeInactiveMessage:
            "Tempo em minutos para envio do aviso de inatividade",
          whenExpiresTicket:
            "Encerrar chats abertos quando última mensagem for",
          expiresInactiveMessage: "Mensagem de encerramento por inatividade",
          prompt: "Prompt",
          collectiveVacationEnd: "Data final",
          collectiveVacationStart: "Data inicial",
          collectiveVacationMessage: "Mensagem de férias coletivas",
          queueIdImportMessages: "Fila para importar as mensagens"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        menuItem: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
          minutes: "minutos",
        },
        messages: {
          clickSaveToRegister: "Clique em salvar para registrar as alterações",
        },
        flowBuilder: {
          welcomeFlow: "Fluxo de boas-vindas",
          welcomeFlowLabel: "Selecione um fluxo de boas-vindas",
          welcomeFlowDescription: "Disparado quando um contato totalmente novo (que ainda não existe na sua base) envia a primeira mensagem para esta conexão.",
          welcomeFlowHelp: "Use para apresentar a empresa, perguntar nome, coletar dados iniciais ou direcionar o cliente para uma fila de forma automática. O fluxo precisa estar criado no FlowBuilder antes de aparecer aqui. Deixe 'Desabilitado' se preferir que novos contatos caiam direto na fila padrão.",
          defaultResponseFlow: "Fluxo de resposta padrão",
          defaultResponseFlowLabel: "Selecione um fluxo de resposta padrão",
          defaultResponseFlowDescription: "Disparado para qualquer mensagem que NÃO bate com uma palavra-chave configurada. Atenção: também é disparado quando o atendimento estiver encerrado há mais de 6 horas.",
          defaultResponseFlowHelp: "Use para responder automaticamente quando o cliente escreve algo fora do esperado, ou após muito tempo de inatividade. Cuidado: se mal configurado pode confundir o cliente em conversas ativas. Recomenda-se um fluxo curto que apenas oriente a entrar em contato em horário comercial. Deixe 'Desabilitado' para silenciar respostas automáticas.",
          infoTitle: "ⓘ O que é Fluxo Padrão",
          infoText: "Permite vincular esta conexão ao <strong>FlowBuilder nativo</strong>, sem precisar selecionar uma integração externa. Existem dois gatilhos:<ul><li><strong>Fluxo de boas-vindas:</strong> roda na primeira mensagem de um contato novo.</li><li><strong>Fluxo de resposta padrão:</strong> roda quando a mensagem não casa com nenhuma palavra-chave ou quando o atendimento está encerrado há mais de 6 horas.</li></ul><strong>Para novas conexões Baileys:</strong> quando já existir fluxo cadastrado, o sistema preenche o fluxo de resposta padrão automaticamente. Você pode trocar ou desabilitar antes de salvar. Os fluxos só executam quando esta conexão estiver online.",
          title: "Fluxo padrão",
          save: "Salvar",
          updatedSuccess: "Fluxos padrões atualizados",
          deleteConfirmation: "Tem certeza que deseja deletar este fluxo? Todas as integrações relacionados serão perdidos.",
        },
        success: "Conexão salvo com sucesso.",
        errorSendQueue:
          "Foi informado tempo para redirecionar fila, porém não foi selecionada fila para redirecionar. Os dois campos precisam estar preenchidos",
        errorExpiresNPS:
          "É obrigado informar um tempo para avaliação quando se utiliza o NPS.",
        errorRatingMessage:
          "É obrigado informar uma mensagem de avaliação quando se utiliza o NPS.",
      },
      qrCode: {
        message: "Leia o QrCode para iniciar a sessão",
      },
      qrcodeModal: {
        title: "Conectar WhatsApp",
        intro: "Use o WhatsApp do celular para escanear o código ao lado e conectar esta sessão. O processo leva poucos segundos.",
        step1: "Abra o <strong>WhatsApp</strong> no seu celular.",
        step2: "Toque em <strong>Mais opções</strong> (Android) ou <strong>Ajustes</strong> (iPhone).",
        step3: "Selecione <strong>Aparelhos conectados</strong> e depois <strong>Conectar um aparelho</strong>.",
        step4: "Aponte a câmera do celular para o QR Code ao lado.",
        statusReady: "Pronto para escanear",
        waiting: "Aguardando QR Code..."
      },
      forbiddenPage: {
        accessDenied: "Oops! Acesso Negado!",
        buttons: {
          back: "Voltar"
        }
      },
      contacts: {
        title: "Contatos",
        subtitleCount: "contatos",
        toasts: {
          deleted: "Contato excluído com sucesso!",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Deletar ",
          importTitlte: "Importar contatos",
          exportContact: "Exportar contatos",
          deleteMessage:
            "Tem certeza que deseja deletar este contato? Todos os atendimentos relacionados serão perdidos.",
          blockContact: "Tem certeza que deseja bloquear este contato?",
          unblockContact: "Tem certeza que deseja desbloquear este contato?",
          importMessage: "Deseja importar todos os contatos do telefone?",
          importChat: "Importar Conversas",
          wantImport: "Deseja importar todas as conversas do telefone?",
        },
        buttons: {
          import: "Importar Contatos",
          add: "Adicionar Contato",
          export: "Exportar Contato",
          edit: "Editar",
          block: "Bloquear",
          unblock: "Desbloquear",
          delete: "Excluir",
          startChat: "Iniciar conversa",
        },
        status: {
          active: "Ativo",
          inactive: "Inativo",
        },
        phantomCleanup: {
          button: "Limpar fantasmas",
          help: "Por que isso acontece?",
          confirmTitle: "Limpar contatos fantasmas",
          confirmMessage: "Foram encontrados {{count}} contatos fantasmas. Eles serão removidos permanentemente do banco. Deseja continuar?",
          noneFound: "Nenhum contato fantasma encontrado na sua base. Tudo limpo!",
          deletedSuccess: "contatos fantasmas removidos",
          helpTitle: "Por que aparecem contatos fantasmas?",
          helpIntro: "Contatos fantasmas são entradas com números inválidos, sem nome, ou criados automaticamente pelo sistema sem corresponder a um contato real do WhatsApp.",
          helpWhy: "Por que isso acontece?",
          helpReason1: "É uma limitação da biblioteca Baileys (que conecta com o WhatsApp Web). Quando o WhatsApp envia eventos de sincronização — broadcasts, listas, status — a biblioteca pode interpretar esses identificadores como contatos novos, mesmo quando eles não representam pessoas reais.",
          helpReason2: "Resultado: aparecem entradas como números muito curtos, com prefixos esquisitos (555000…, 120363…), ou sem dígitos suficientes para ser um telefone válido.",
          helpFixTitle: "O que essa limpeza faz?",
          helpFixBody: "Identifica contatos com número inválido (formato fora do padrão E.164, sequências repetidas, prefixos suspeitos) ou criados automaticamente fora da agenda, e remove permanentemente do banco. Contatos legítimos não são afetados.",
          helpClose: "Entendi",
        },
        table: {
          name: "Nome",
          whatsapp: "WhatsApp",
          email: "Email",
          connection: "Conexão",
          actions: "Ações",
          lastMessage: "Última Mensagem",
          status: "Status",
          source: "Origem",
          followUp: "Follow-up",
          tags: "Tags",
          products: "Produto",
          payment: "Pagamento",
          attendant: "Atendente",
          selectAll: "Selecionar todos os contatos",
          selectContact: "Selecionar contato {{name}}",
        },
        productStatus: {
          pending: "Pendente",
          completed: "Concluído",
          cancelled: "Cancelado",
          refunded: "Reembolsado",
          in_progress: "Em Andamento",
        },
        menu: {
          importYourPhone: "Importar do aparelho padrão",
          importToExcel: "Importar / Exportar do Excel",
          importExport: "Importar / Exportar",
        },
        bulkActions: {
          deleteSelected: "Deletar Selecionados ({{count}})",
          deleteConfirmTitle: "Tem certeza que deseja deletar {{count}} contatos selecionados?",
          deleteConfirmMessage: "Essa ação é irreversível.",
          deleteSuccess: "Contatos selecionados deletados com sucesso!",
          blockContact: "Contato bloqueado",
          unblockContact: "Contato desbloqueado",
          selectConnectionToImport: "Escolha de qual conexão deseja importar",
        },
        filters: {
          title: "Filtros",
          any: "Qualquer",
          clearAll: "Limpar filtros",
          apply: "Aplicar",
          tagsLabel: "Tags",
          showLabel: "Exibir",
          showOnlyAgenda: "Somente minha agenda",
          showAll: "Todos os contatos",
          source: "Origem",
          sourceAll: "Todos",
          sourceManual: "Manual",
          sourceWhatsappRoster: "WhatsApp (agenda)",
          sourceExcelImport: "Excel/CSV",
          sourceAutoCreated: "Auto-criados",
          sourceChatImport: "Chats"
        },
        source: {
          manual: "Criado manualmente",
          whatsappRoster: "Importado do WhatsApp",
          excelImport: "Importado de Excel/CSV",
          autoCreated: "Auto-criado por mensagem",
          chatImport: "Importado de chats"
        },
      },
      tagsFilter: {
        placeholder: "Filtro por Tags",
      },
      newTicketModal: {
        selectQueue: "Selecione uma fila",
        selectConnection: "Selecione uma Conexão",
        queueError: "Selecione uma fila",
        close: "Fechar",
      },
      contactImportWpModal: {
        modalTitle: "Exportar / Importar Contatos",
        title: "Exportar Contatos para o Excel",
        buttons: {
          downloadModel: "Download modelo do excel para importação",
          closed: "Fechar",
          import: "Selecione o arquivo do excel para importar Contatos",
        },
        form: {
          connection: "Conexão do WhatsApp",
          connectionPlaceholder: "Selecionar conexão...",
          importType: "Tipo de importação",
          importAll: "Importar todos os contatos",
          importSelected: "Importar contatos selecionados",
          overwriteExisting: "Sobrescrever contatos existentes"
        },
        validation: {
          connectionRequired: "Você deve selecionar uma conexão",
          noContactsFound: "Nenhum contato encontrado para importar"
        },
        progress: {
          importing: "Importando contatos...",
          imported: "Contatos importados: {count}",
          duplicated: "Contatos duplicados: {count}",
          failed: "Contatos com falha: {count}"
        },
        importComplete: "Importação concluída com sucesso",
        importInProgress: "Importação em andamento {current} de {total} - não saia desta tela até concluir a importação",
        sheetName: "Contatos",
        columns: {
          name: "Nome",
          number: "Número",
          email: "E-mail",
          tags: "Tags",
          followUp: "Follow-up",
          productName: "Produto (Nome)",
          productStatus: "Produto (Status)",
        },
        sampleContact: {
          name: "João",
          number: "5599999999999",
          email: "joao@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "concluído",
        },
      },
      tagsContainer: {
        tagTooShort: "Tag muito curta!",
        placeholder: "Tags",
      },
      validation: {
        required: "Obrigatório",
        tooShort: "Muito curto!",
        tooLong: "Muito longo!",
        invalidEmail: "Email inválido",
        emailPlaceholder: "Endereço de email",
        phonePlaceholder: "Ex: +55 13 91234-4321 (opcional)",
      },
      contactImport: {
        title: "Importar contatos de arquivo",
        subtitle: "Envie um arquivo XLS, XLSX, CSV ou TXT para importar contatos em lote",
        validation: {
          noNumberField: "Não foi selecionado o campo de número do contato",
          noNameField: "Não foi selecionado o campo de nome do contato",
          noContactsSelected: "Nenhum contato selecionado",
          fieldAlreadySelected: "O campo {{field}} já foi selecionado."
        },
        messages: {
          successComplete: "Importação realizada com sucesso",
          successWithErrors: "Importação realizada com sucesso, mas houveram alguns erros",
          importing: "Importando... Aguarde",
          processing: "Processando arquivo...",
          invalidFile: "Arquivo inválido!",
          contactsCreated: "contatos criados",
          contactsIgnored: "contatos ignorados (número inválido ou não marcados para atualizar)"
        },
        fields: {
          name: "Nome",
          number: "Número",
          email: "E-mail",
          tags: "Tags",
          followUp: "Follow-up (Acompanhamento)",
          productName: "Produto (Nome)",
          productStatus: "Produto (Status)"
        },
        buttons: {
          downloadModel: "Baixar modelo",
          validateWhatsApp: "Validar contatos no WhatsApp",
          importContacts: "Importar contatos",
          cancel: "Cancelar",
          back: "Voltar"
        },
        dropzone: {
          clickOrDrag: "Clique ou arraste um arquivo",
          importantNote: "* Importante: Arquivos somente com extensões são aceitas: xls, xslx, csv, txt"
        },
        sheetName: "Contatos",
        sampleContact: {
          name: "João",
          number: "5599999999999",
          email: "joao@email.com",
          tags: "cliente, vip",
          followUp: "",
          productName: "Curso Marketing",
          productStatus: "concluído"
        },
        filters: {
          filter: "Filtrar",
          clearAll: "Limpar filtros",
          noResults: "Nenhum resultado encontrado"
        }
      },
      forwardMessage: {
        text: "Encaminhada",
      },
      forwardMessageModal: {
        title: "Encaminhar mensagens para",
        searchPlaceholder: "Pesquisar nome ou número",
        recentConversations: "Conversas recentes",
        createContact: "Criar contato \"{{name}}\"",
        typeToSearch: "Digite para buscar contatos.",
        selectedMessage: "{{count}} mensagem selecionada",
        selectedMessages: "{{count}} mensagens selecionadas",
        selectedRecipient: "{{count}} destinatário selecionado",
        selectedRecipients: "{{count}} destinatários selecionados",
        sending: "Enviando {{target}}...",
        buttons: {
          ok: "Encaminhar",
        },
      },
      promptModal: {
        form: {
          name: "Nome",
          prompt: "Prompt",
          voice: "Voz",
          max_tokens: "Máximo de Tokens na resposta",
          temperature: "Temperatura",
          apikey: "API Key",
          max_messages: "Máximo de mensagens no Histórico",
          voiceKey: "Chave da API de Voz",
          voiceRegion: "Região de Voz",
          model: "Modelo",
        },
        success: "Prompt salvo com sucesso!",
        title: {
          add: "Adicionar Prompt",
          edit: "Editar Prompt",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          promptDescription: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          informQueue: "Informe a fila",
          minMessages: "Mínimo 1 mensagem",
          maxMessages: "Máximo 50 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          informVoiceMode: "Informe o modo para Voz"
        },
        errors: {
          savePrompt: "Erro ao salvar o prompt"
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voices: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antônio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fábio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Letícia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valério",
          yara: "Yara"
        }
      },
      prompts: {
        title: "Prompts",
        table: {
          name: "Nome",
          queue: "Setor/Fila",
          max_tokens: "Máximo Tokens Resposta",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Você tem certeza? Essa ação não pode ser revertida!",
        },
        buttons: {
          add: "Adicionar Prompt",
        },
        errors: {
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando."
        },
      },
      contactModal: {
        title: {
          add: "Adicionar contato",
          edit: "Editar contato",
          createCard: "Criar card",
        },
        form: {
          kanbanLane: "Coluna do Kanban",
          kanbanLaneHelp: "Selecione em qual coluna o card será criado.",
          mainInfo: "Dados do contato",
          extraInfo: "Informações adicionais",
          name: "Nome",
          number: "Número do WhatsApp",
          optional: "opcional",
          email: "Email",
          extraName: "Nome do campo",
          extraValue: "Descrição",
          chatBotContact: "Desabilitar chatbot",
          followUp: "Follow-up (Acompanhamento)",
          followUpPlaceholder: "Anotações de acompanhamento do contato...",
          termsLGDP: "Termos LGPD aceito em:",
          whatsapp: "Conexão Origem: ",
          numberPlaceholder: "5513912344321",
          emailPlaceholder: "Endereço de email",
          products: "Produtos",
          productName: "Nome do produto",
          tags: "Tags",
          tagsPlaceholder: "Selecione ou crie tags",
        },
        buttons: {
          addExtraInfo: "Adicionar informação",
          addProduct: "Adicionar",
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Contato salvo com sucesso.",
      },
      contactTagListModal: {
        title: "Contatos",
        table: {
          id: "ID",
          name: "Nome",
          number: "Número",
          actions: "Ações"
        }
      },
      flowbuilder: {
        title: "Fluxos de conversa",
        subtitle: "Gerencie fluxos de conversa e automações de atendimento",
        subMenus: {
          campaign: "Fluxo de Campanha",
          conversation: "Fluxo de Conversa"
        },
        buttons: {
          add: "Adicionar Fluxo",
          editName: "Editar nome",
          editFlow: "Editar fluxo",
          duplicate: "Duplicar",
          delete: "Excluir"
        },
        table: {
          status: "Status"
        },
        status: {
          active: "Ativo",
          inactive: "Desativado"
        },
        toasts: {
          deleteSuccess: "Fluxo excluído com sucesso",
          duplicateSuccess: "Fluxo duplicado com sucesso"
        },
        confirmationModal: {
          deleteTitle: "Tem certeza que deseja deletar este fluxo? Todas as integrações relacionados serão perdidos.",
          duplicateTitle: "Deseja duplicar o fluxo {flowName}?",
          duplicateMessage: "Tem certeza que deseja duplicar este fluxo?"
        }
      },
      knowledgeBase: {
        title: "Base de Conhecimento",
        tabs: {
          rag: "Base de Conhecimento (RAG)",
          qualification: "Qualificação do Agente",
        },
        rag: {
          title: "Base de Conhecimento",
          subtitle: "Fontes e conteúdos usados pelo agente para responder com RAG",
          actions: {
            refresh: "Atualizar",
            newBase: "Nova Base RAG",
            createFirst: "Criar primeira base",
            createBase: "Criar Base",
            cancel: "Cancelar",
            processing: "Processando...",
            indexKnowledge: "Indexar Conhecimento",
          },
          stats: {
            created: "Bases criadas",
            indexed: "Bases indexadas",
            totalChunks: "Chunks totais",
          },
          empty: {
            title: "Nenhuma base de conhecimento criada",
            description: "Crie uma base e faça upload de documentos (PDF, TXT, CSV) ou cole texto. O agente de IA usará essas informações para responder seus clientes.",
          },
          table: {
            name: "Nome",
            type: "Tipo",
            file: "Arquivo",
            createdAt: "Criado em",
            actions: "Ações",
          },
          status: {
            pending: "Pendente",
            processing: "Processando",
            indexed: "Indexado",
            error: "Erro",
            active: "Ativo",
            importing: "Importando",
          },
          sourceTypes: {
            text: "Texto",
            pdf: "PDF",
            csv: "CSV",
            url: "URL",
          },
          tooltips: {
            index: "Indexar conteúdo",
            delete: "Excluir",
          },
          dialogs: {
            newBaseTitle: "Nova Base de Conhecimento",
            indexTitle: "Indexar Conteúdo - {{name}}",
            indexDescription: "Escolha como deseja adicionar conteúdo. Ele será dividido em chunks e indexado com embeddings para busca semântica pelo agente de IA.",
            processingDescription: "Processando inteligência... Isso pode levar alguns minutos.",
          },
          form: {
            name: "Nome",
            namePlaceholder: "Ex.: Catálogo de Produtos, FAQ, Políticas...",
            description: "Descrição",
            descriptionPlaceholder: "Descreva o conteúdo desta base...",
            sourceType: "Tipo de Fonte",
            chunkSize: "Tamanho do Chunk",
            recommended512: "Recomendado: 512",
            recommended50: "Recomendado: 50",
            apiKeyHelp: "Necessária para gerar embeddings",
            filePlaceholder: "Clique para selecionar arquivo (PDF, TXT, CSV...)",
            content: "Conteúdo",
            contentPlaceholder: "Cole aqui o texto...",
            siteUrl: "URL do site",
            siteUrlHelp: "Insira a URL completa",
          },
          ingestModes: {
            file: "Arquivo",
            text: "Texto",
          },
          toasts: {
            created: "Base criada com sucesso!",
            deleted: "Base excluída!",
            fillContent: "Preencha o conteúdo, selecione um arquivo ou insira uma URL.",
            indexed: "Conteúdo indexado com sucesso!",
          },
          confirm: {
            deleteBase: "Tem certeza que deseja excluir esta base de conhecimento?",
          },
        },
        datasets: {
          titles: {
            catalogs: "Catálogos",
            qualification: "Qualificação do Agente",
          },
          subtitles: {
            catalogs: "Dados estruturados para consulta de produtos, preços e disponibilidade",
            qualification: "Campos e datasets que o agente deve preencher durante o atendimento",
          },
          dialogs: {
            newCatalogTitle: "Novo Catálogo",
            newQualificationTitle: "Nova Qualificação",
            importTitle: "Importar Dados - {{name}}",
            processingImport: "Processando importação...",
          },
          form: {
            name: "Nome",
            catalogName: "Nome do catálogo",
            description: "Descrição (opcional)",
            fieldName: "Nome do campo",
            type: "Tipo",
          },
          actions: {
            addField: "Adicionar campo",
            refresh: "Atualizar",
            newCatalog: "Novo Catálogo",
            newQualification: "Nova Qualificação",
            createCatalog: "Criar Catálogo",
            createQualification: "Criar Qualificação",
            createFirstCatalog: "Criar primeiro catálogo",
            createFirstQualification: "Criar primeira qualificação",
            importData: "Importar Dados",
            cancel: "Cancelar",
          },
          stats: {
            datasets: "Datasets",
            totalRows: "Linhas totais",
          },
          empty: {
            catalogTitle: "Nenhum catálogo criado",
            qualificationTitle: "Nenhuma qualificação criada",
            catalogDescription: "Crie um catálogo e importe dados (CSV, Google Sheets). O agente de IA usará esses dados para consultar produtos, preços e disponibilidade.",
            qualificationDescription: "Crie os campos que o agente de IA deve preencher durante o atendimento (ex.: nome, interesse, temperatura do lead).",
          },
          table: {
            name: "Nome",
            source: "Fonte",
            columns: "Colunas",
            rows: "Linhas",
            createdAt: "Criado em",
            type: "Tipo",
            mode: "Modo",
            actions: "Ações",
          },
          tooltips: {
            viewData: "Ver dados",
            importData: "Importar dados",
            delete: "Excluir",
            resyncGoogleSheets: "Ressincronizar Google Sheets",
          },
          status: {
            pending: "Pendente",
            processing: "Processando",
            indexed: "Indexado",
            error: "Erro",
            active: "Ativo",
            importing: "Importando",
          },
          columnTypes: {
            text: "Texto",
            number: "Número",
            currency: "Moeda (R$)",
            date: "Data",
            boolean: "Sim/Não",
            url: "URL / Link",
            image: "Imagem (URL)",
            email: "E-mail",
            phone: "Telefone",
            select: "Lista de opções",
            textarea: "Texto longo",
            json: "JSON",
          },
          importModes: {
            csv: "Arquivo CSV",
          },
          modes: {
            ask: "Pergunta",
            internal: "Interno",
          },
          toasts: {
            created: "Dataset criado!",
            deleted: "Dataset excluído!",
            noSourceUrl: "Este dataset não tem URL de origem para ressincronizar.",
            fillImportSource: "Preencha a URL do Google Sheets ou selecione um arquivo CSV.",
            imported: "Dados importados com sucesso!",
            resyncing: "Ressincronizando dados do Google Sheets...",
            resynced: "Dados ressincronizados!",
            columnAdded: "Coluna adicionada!",
          },
          confirm: {
            deleteDataset: "Excluir este dataset e todos os dados?",
            removeColumn: "Remover a coluna \"{{column}}\"? Os dados dessa coluna serão perdidos.",
          },
          form: {
            name: "Nome",
            catalogName: "Nome do catálogo",
            description: "Descrição (opcional)",
            fieldName: "Nome do campo",
            type: "Tipo",
            googleSheetsLink: "Link do Google Sheets",
            csvPlaceholder: "Clique para selecionar arquivo CSV",
            newFieldPlaceholder: "Novo campo...",
          },
        },
      },
      flowbuilderModal: {
        flowNotIdPhrase: "Fluxo padrão",
        title: {
          add: "Adicionar Fluxo",
          edit: "Editar Fluxo"
        },
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Digite um nome!"
        }
      },
      queueModal: {
        title: {
          queueData: "Dados da fila",
          text: "Horário de expediente",
          add: "Adicionar fila",
          edit: "Editar fila",
          confirmationDelete:
            "Tem certeza? Todas as opções de integrações serão deletadas.",
        },
        info: {
          intro: {
            title: "ⓘ O que é uma fila",
            text: "<strong>Filas</strong> (departamentos) organizam o atendimento. Cada conexão pode ser vinculada a uma ou mais filas, e os atendentes só veem tickets das filas em que são membros.<ul><li>Defina <strong>nome</strong> e <strong>cor</strong> para identificar a fila visualmente.</li><li>A <strong>mensagem de saudação</strong> é enviada quando o cliente entra nessa fila.</li><li>O <strong>roteador</strong> distribui automaticamente tickets entre os atendentes online.</li></ul><strong>Para automação avançada</strong>, use o <em>FlowBuilder</em> e selecione o fluxo na conexão WhatsApp."
          }
        },
        sections: {
          identity: "Identificação",
          identityDesc: "Nome, cor e ordem de exibição da fila.",
          behavior: "Comportamento",
          behaviorDesc: "Define ações automáticas quando o ticket entra ou é atribuído nesta fila.",
          messages: "Mensagens automáticas",
          messagesDesc: "Textos enviados automaticamente em momentos específicos do atendimento."
        },
        help: {
          name: "Nome interno da fila. Aparece em listas e relatórios. Use algo descritivo (ex: 'Suporte', 'Vendas BR').",
          color: "Cor do tag visual da fila. Aparece nas listas de tickets, no chat e nos relatórios.",
          orderQueue: "Posição numérica desta fila nos menus do bot. Filas com número menor aparecem antes. Use 0 para ocultar.",
          closeTicket: "Quando ativado, o ticket é encerrado automaticamente ao final do fluxo do bot. Útil para FAQs e atendimentos 100% automatizados.",
          rotate: "Roteador automático: redistribui tickets sem atendente atribuído entre os agentes online da fila a cada X minutos.",
          tempoRoteador: "Intervalo (em minutos) entre cada redistribuição automática. Recomendado: 5 a 10 minutos.",
          greetingMessage: "Texto enviado ao cliente quando o ticket entra nesta fila. Pode incluir variáveis como {{name}} (nome do contato) e {{queue}}."
        },
        form: {
          name: "Nome",
          color: "Cor",
          orderQueue: "Ordem da fila (Bot)",
          rotate: "Rodízio",
          timeRotate: "Tempo de Rodízio",
          greetingMessage: "Mensagem de saudação",
          complationMessage: "Mensagem de conclusão",
          outOfHoursMessage: "Mensagem de fora de expediente",
          token: "Token",
          integrationId: "Integração",
          fileListId: "Lista de arquivos",
          closeTicket: "Fechar ticket",
          queueType: "Tipo de menu",
          message: "Mensagem de retorno",
          queue: "Fila para transferência",
          integration: "Integração",
          file: "Lista de arquivos",
          selectFile: "Selecione um arquivo",
          timeOptions: {
            minutes2: "2 minutos",
            minutes5: "5 minutos",
            minutes10: "10 minutos",
            minutes15: "15 minutos",
            minutes30: "30 minutos",
            minutes45: "45 minutos",
            minutes60: "60 minutos",
          },
        },
        validations: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          mustHaveFriends: "Deve ter amigos",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        bot: {
          title: "Opções",
          toolTipTitle: "Adicione opções para construir um chatbot",
          toolTip:
            "Se houver apenas uma opção, ela será escolhida automaticamente, fazendo com que o bot responda com a mensagem da opção e siga adiante",
          selectOption: "Selecione uma opção",
          text: "Texto",
          attendent: "Atendente",
          queue: "Fila",
          integration: "Integração",
          file: "Arquivo",
          toolTipMessageTitle:
            "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipMessageContent:
            "A mensagem é obrigatória para seguir ao próximo nível",
          selectUser: "Selecione um Usuário",
          selectQueue: "Selecione uma Fila",
          selectIntegration: "Selecione uma Integração",
          addOptions: "Adicionar opções",
          confirmationDelete: "Tem certeza? Todas as opções internas também serão excluídas",
          messageLabel: "Mensagem:",
          toolTipMessage: "A mensagem é obrigatória para seguir ao próximo nível",
          toolTipContent: "Se a mensagem não estiver definida, o bot não seguirá adiante",
        },
        serviceHours: {
          dayWeek: "Dia da semana",
          startTimeA: "Hora Inicial - Turno A",
          endTimeA: "Hora Final - Turno A",
          startTimeB: "Hora Inicial - Turno B",
          endTimeB: "Hora Final - Turno B",
          monday: "Segunda-feira",
          tuesday: "Terça-feira",
          wednesday: "Quarta-feira",
          thursday: "Quinta-feira",
          friday: "Sexta-feira",
          saturday: "Sábado",
          sunday: "Domingo",
        },
        general: {
          none: "Nenhum",
          message: "Mensagem:",
        },
      },
      colorBoxModal: {
        title: "Escolha uma cor",
        eyeDropper: "Capturar cor da tela",
        buttons: {
          cancel: "Cancelar",
          ok: "OK",
        },
        tooltips: {
          copy: "Copiar cor",
          copied: "Copiado!",
        },
      },
      queueIntegrationModal: {
        title: {
          add: "Adicionar projeto",
          edit: "Editar projeto",
        },
        info: {
          intro: {
            title: "ⓘ O que são integrações de fluxo",
            text: "Integrações conectam esta plataforma a sistemas externos de automação:<ul><li><strong>N8N:</strong> orquestrador de workflows visual — você cria automações com gatilhos, condições e ações que são acionadas a cada mensagem recebida.</li><li><strong>Typebot:</strong> construtor de chatbots conversacionais — o cliente conversa com um fluxo guiado de perguntas e respostas pré-definido.</li></ul><strong>Como funciona:</strong> ao receber uma mensagem, o sistema envia os dados para a URL configurada e processa a resposta retornada. A integração é selecionada por conexão na aba <em>Integrações</em> do whatsapp."
          }
        },
        sections: {
          type: "Tipo de integração",
          typeDesc: "Escolha o serviço externo que vai processar as mensagens.",
          n8nConfig: "Configuração do N8N",
          n8nConfigDesc: "Informe um nome para identificar esta integração e a URL do webhook que receberá os eventos.",
          typebotConnection: "Conexão com o Typebot",
          typebotConnectionDesc: "Identifique a integração e informe o servidor + slug do bot publicado no Typebot.",
          typebotBehavior: "Comportamento da conversa",
          typebotBehaviorDesc: "Controla tempo de expiração, delay entre mensagens e palavras-chave que encerram ou reiniciam o bot."
        },
        help: {
          name: "Nome interno para identificar esta integração na lista (ex: 'Bot atendimento N8N').",
          urlN8N: "URL completa do webhook do seu workflow no N8N. Encontre em: nó Webhook → 'Production URL'. Deve ser publicamente acessível pelo backend desta plataforma.",
          urlTypebot: "URL base do servidor Typebot (ex: 'https://typebot.io' para a versão oficial ou o domínio da sua instância self-hosted).",
          typebotSlug: "Identificador público do bot publicado. Encontre na aba Share do seu Typebot — é a parte final da URL (ex: 'meu-bot-123').",
          typebotExpires: "Tempo (em horas) que a sessão do bot fica ativa sem nova mensagem do contato. Após esse período, o fluxo reinicia. Use 0 para nunca expirar.",
          typebotDelayMessage: "Tempo (em ms) que o bot espera antes de enviar cada resposta. Simula digitação humana. Recomendado: 1000-2000ms.",
          typebotKeywordFinish: "Palavra que, quando enviada pelo cliente, encerra imediatamente o fluxo do bot e libera o atendimento humano (ex: 'sair', 'atendente').",
          typebotKeywordRestart: "Palavra que reinicia o fluxo do bot do zero (ex: 'reiniciar', 'menu'). O cliente volta para a primeira pergunta do Typebot.",
          typebotUnknownMessage: "Mensagem que o bot envia quando recebe uma resposta que não entende ou que não bate com nenhuma opção do fluxo (ex: 'Não entendi, pode reformular?').",
          typebotRestartMessage: "Mensagem enviada automaticamente quando o fluxo é reiniciado pela palavra-chave acima (ex: 'Vamos começar de novo!')."
        },
        form: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          jsonContent: "JsonContent",
          urlN8N: "URL",
          urlN8NWebhook: "URL do Webhook (do N8N)",
          typebotSlug: "Typebot - Slug",
          typebotExpires: "Tempo em minutos para expirar uma conversa",
          typebotKeywordFinish: "Palavra para finalizar o ticket",
          typebotKeywordRestart: "Palavra para reiniciar o fluxo",
          typebotRestartMessage: "Mensagem ao reiniciar a conversa",
          typebotUnknownMessage: "Mensagem de opção inválida",
          typebotDelayMessage: "Intervalo (ms) entre mensagens",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          test: "Testar Bot",
        },
        languages: {
          "pt-BR": "Português",
          "en": "Inglês",
          "es": "Español",
        },
        instructions: {
          n8nTitle: "Como configurar a integração com N8N (passo a passo)",
          n8nStep1: "No seu N8N, crie um novo workflow e adicione o nó \"Webhook\" como primeiro nó (trigger).",
          n8nStep2: "No nó Webhook, configure o método como POST. O N8N vai gerar uma URL como: https://seu-n8n.com/webhook/abc123",
          n8nStep3: "Copie essa URL do webhook e cole no campo \"URL do Webhook\" acima.",
          n8nStep4: "Monte o restante do seu workflow no N8N (ex: conectar a uma IA, consultar banco de dados, enviar e-mail, etc).",
          n8nStep5: "Depois de salvar aqui, vá em Conexões (WhatsApp) ou Filas e vincule esta integração. Toda mensagem recebida nessa conexão/fila será enviada automaticamente ao N8N.",
          n8nDataTitle: "Dados que o N8N vai receber:",
          n8nReplyTitle: "Como o N8N responde ao cliente:",
          n8nReplyOption1: "Opção 1 (mais simples) - No último nó do workflow, use \"Respond to Webhook\" e retorne:",
          n8nReplyOption2: "Opção 2 (mais controle) - Use o nó \"HTTP Request\" para chamar a API diretamente. Os dados apiToken e apiUrl já vêm no webhook:",
          n8nTip: "Dica: O token da API fica em Conexões > editar a conexão WhatsApp > campo Token. Mas com a Opção 1 acima, você nem precisa se preocupar com isso - basta retornar o texto no \"reply\".",
          webhookTitle: "Como configurar o Webhook",
          webhookStep1: "Configure seu sistema externo para receber requisições POST no endpoint desejado.",
          webhookStep2: "Cole a URL do endpoint no campo acima. Cada mensagem recebida será enviada como POST com os dados do contato, ticket e mensagem.",
          webhookStep3: "Se o endpoint retornar { \"reply\": \"texto\" } na resposta, o sistema enviará automaticamente essa mensagem ao cliente no WhatsApp.",
        },
        messages: {
          testSuccess: "Integração testada com sucesso!",
          addSuccess: "Integração adicionada com sucesso.",
          editSuccess: "Integração editada com sucesso.",
        },
      },
      userModal: {
        warning:
          "Para fazer a importação das mensagens é necessário ler o qrCode novamente !!!",
        title: {
          add: "Adicionar usuário",
          edit: "Editar usuário",
          updateImage: "Atualizar imagem",
          removeImage: "Excluir imagem",
        },
        form: {
          name: "Nome",
          canViewAllContacts: "Visualizar Todos os Contatos",
          none: "Nenhuma",
          email: "Email",
          password: "Senha",
          farewellMessage: "Mensagem de despedida",
          profile: "Perfil",
          startWork: "Inicio de trabalho",
          endWork: "Fim de trabalho",
          whatsapp: "Conexão Padrão",
          allTicketEnable: "Habilitado",
          allTicketDisable: "Desabilitado",
          allTicket: "Visualizar chamados sem fila",
          allowGroup: "Permitir Grupos",
          defaultMenuOpen: "Aberto",
          defaultMenuClosed: "Fechado",
          defaultMenu: "Menu padrão",
          defaultTheme: "Tema Padrão",
          defaultThemeDark: "Escuro",
          defaultThemeLight: "Claro",
          allHistoric: "Ver conversas de outras filas",
          allHistoricEnabled: "Habilitado",
          allHistoricDisabled: "Desabilitado",
          allUserChat: "Ver conversas de outros usuários",
          userClosePendingTicket: "Permitir fechar tickets pendentes",
          showDashboard: "Ver Dashboard",
          allowRealTime: "Ver Painel de Atendimentos",
          allowConnections: "Permitir ações nas conexões",
        },
        tabs: {
          general: "Geral",
          permissions: "Permissões",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addImage: "Adicionar Imagem",
          editImage: "Editar Imagem",
        },
        success: "Usuário salvo com sucesso.",
      },
      companyModal: {
        title: {
          add: "Adicionar empresa",
          edit: "Editar empresa",
        },
        form: {
          name: "Nome",
          email: "Email",
          passwordDefault: "Senha",
          numberAttendants: "Usuários",
          numberConections: "Conexões",
          status: "Ativo",
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        success: "Empresa salvo com sucesso.",
        validations: {
          nameRequired: "Nome é obrigatório",
          emailInvalid: "Email é inválido",
          emailRequired: "E-mail é obrigatório",
          passwordRequired: "Senha é obrigatória",
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
        },
      },
      scheduleModal: {
        title: {
          add: "Novo Agendamento",
          edit: "Editar Agendamento",
        },
        form: {
          body: "Mensagem",
          contact: "Contato",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          assinar: "Enviar Assinatura",
          date: "Data",
          time: "Hora",
          timezoneHelper: "Fuso horário: {{tz}} | Hora atual: {{time}}",
          timezoneHelperShort: "Fuso horário: {{tz}}"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
          addSchedule: "Adicionar agendamento"
        },
        success: "Agendamento salvo com sucesso.",
        validations: {
          tooShort: "Mensagem muito curta",
          required: "Obrigatório",
          notPast: "A data não pode ser no passado."
        },
        toasts: {
          deleted: "Mídia removida com sucesso."
        },
        confirmationModal: {
          deleteTitle: "Excluir Mídia",
          deleteMessage: "Tem certeza que deseja excluir esta mídia?"
        },
        status: {
          sending: "Enviando",
          pending: "Pendente",
          sent: "Enviado",
          error: "Erro de Envio"
        },
        recurrence: {
          title: "Recorrência",
          description: "Você pode escolher enviar a mensagem de forma recorrente e escolher o intervalo. Caso seja uma mensagem a ser enviada uma unica vez, não altere nada nesta seção.",
          interval: "Intervalo",
          intervalValue: "Valor do Intervalo",
          sendTimes: "Enviar quantas vezes",
          intervalTypes: {
            days: "Dias",
            weeks: "Semanas",
            months: "Meses",
            minutes: "Minutos"
          },
          businessDays: {
            normal: "Enviar normalmente em dias não úteis",
            before: "Enviar um dia útil antes",
            after: "Enviar um dia útil depois"
          }
        },
        calendar: {
          messages: {
            date: "Data",
            time: "Hora",
            event: "Evento",
            allDay: "Dia Todo",
            week: "Semana",
            work_week: "Agendamentos",
            day: "Dia",
            month: "Mês",
            previous: "Anterior",
            next: "Próximo",
            yesterday: "Ontem",
            tomorrow: "Amanhã",
            today: "Hoje",
            agenda: "Agenda",
            noEventsInRange: "Não há agendamentos no período.",
            showMore: "mais"
          }
        },
        permissions: {
          noAccess: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando."
        }
      },
      tagModal: {
        title: {
          add: "Nova Tag",
          edit: "Editar Tag",
          addKanban: "Nova Lane",
          editKanban: "Editar Lane",
        },
        form: {
          name: "Nome",
          color: "Cor",
          timeLane: "Tempo em horas para redirecionar para lane",
          timeOnLane: "Tempo na lane",
          days: "Dias",
          hours: "Horas",
          minutes: "Minutos",
          seconds: "Segundos",
          nextLaneId: "Lane seguinte",
          greetingMessageLane: "Mensagem de saudação da lane",
          rollbackLaneId: "Voltar para Lane após retomar atendimento"
        },
        buttons: {
          okAdd: "Adicionar",
          okEdit: "Salvar",
          cancel: "Cancelar",
        },
        validation: {
          tooShort: "Mensagem muito curta",
          required: "Obrigatório"
        },
        success: "Tag salva com sucesso.",
        successKanban: "Lane salva com sucesso.",
      },
      fileModal: {
        title: {
          add: "Adicionar lista de arquivos",
          edit: "Editar lista de arquivos",
        },
        buttons: {
          okAdd: "Salvar",
          okEdit: "Editar",
          cancel: "Cancelar",
          fileOptions: "Adicionar arquivo",
        },
        form: {
          name: "Nome da lista de arquivos",
          message: "Detalhes da lista",
          fileOptions: "Lista de arquivos",
          extraName: "Mensagem para enviar com arquivo",
          extraValue: "Valor da opção",
        },
        success: "Lista de arquivos salva com sucesso!",
      },
      chat: {
        noTicketMessage: "Selecione um ticket para começar a conversar.",
        deleteConversationTitle: "Excluir Conversa",
        deleteConversationMessage: "Esta ação não pode ser revertida, confirmar?",
        messagePlaceholder: "Digite sua mensagem...",
        sendButtonTooltip: "Enviar mensagem",
        noMessagesYet: "Nenhuma mensagem ainda. Comece a conversa!",
        loadingMessages: "Carregando mensagens...",
        popover: {
          buttonTooltip: "Conversas internas",
          loading: "Carregando conversas...",
          noChats: "Nenhuma conversa disponível",
          notificationNotSupported: "Este navegador não suporta notificações",
          accessibilityLabel: "Lista de conversas internas",
        },
      },
      uploads: {
        titles: {
          titleUploadMsgDragDrop:
            "⬇️ ARRASTE E SOLTE ARQUIVOS NO CAMPO ABAIXO ⬇️",
          titleFileList: "Lista de arquivo(s)",
        },
      },
      chatInternal: {
        new: "Nova",
        tabs: {
          chats: "Chats",
          messages: "Mensagens",
        },
        form: {
          titleLabel: "Título",
          titlePlaceholder: "Título",
        },
        modal: {
          conversation: "Conversa",
          title: "Título",
          filterUsers: "Filtro por Usuários",
          cancel: "Fechar",
          save: "Salvar",
        },
        modalDelete: {
          title: "Excluir Conversa",
          message: "Esta ação não pode ser revertida, confirmar?",
        },
      },
      ticketsManager: {
        questionCloseTicket: "VOCÊ DESEJA FECHAR TODOS OS TICKETS?",
        yes: "SIM",
        not: "NÃO",
        buttons: {
          newTicket: "Novo",
          resolveAll: "Resolver Todos",
          close: "Fechar",
          new: "Novo",
        },
      },
      ticketsQueueSelect: {
        placeholder: "Filas",
      },
      tickets: {
        inbox: {
          closedAllTickets: "Fechar todos os tickets?",
          closedAll: "Fechar Todos",
          newTicket: "Novo Ticket",
          yes: "SIM",
          no: "NÃO",
          open: "Abertos",
          resolverd: "Resolvidos",
        },
        toasts: {
          deleted: "O atendimento que você estava foi deletado.",
        },
        notification: {
          message: "Mensagem de",
        },
        tabs: {
          open: { title: "Abertas" },
          closed: { title: "Resolvidos" },
          search: { title: "Busca" },
        },
        search: {
          placeholder: "Buscar atendimento e mensagens",
          filterConections: "Filtro por Conexão",
          filterConectionsOptions: {
            open: "Aberto",
            closed: "Fechado",
            pending: "Pendente",
          },
          filterUsers: "Filtro por Usuarios",
          filterContacts: "Filtro por Contatos",
          ticketsPerPage: "Tickets por página",
        },
        buttons: {
          showAll: "Todos",
          returnQueue: "Devolver a Fila",
          scredule: "Agendamento",
          deleteTicket: "Deletar Ticket",
          quickMessageFlash: "Respostas rápidas",
        },
        noContactName: "(sem contato)",
        noDepartment: "Sem departamento",
        group: "Grupo",
        transferTooltip: "Transferir Ticket",
        closedTicket: {
          closedMessage: "Fechar Ticket Com Mensagem de Despedida",
          closedNotMessage: "Fechar Ticket Sem Mensagem de Despedida",
        },
      },
      messages: {
        download: "Download",
        today: "HOJE",
        contact: "Contato",
        forwarded: "Encaminhada",
        deletedByContact: "🚫 Essa mensagem foi apagada pelo contato &nbsp;",
        deletedMessage: "🚫 _Mensagem apagada_ ",
        deletedBySender: "🚫 Essa mensagem foi apagada &nbsp;",
        youReacted: "Você reagiu... ",
        sayHello: "Diga olá para seu novo contato!",
        dropFile: "Solte o arquivo aqui",
        facebookPolicy: "Você tem 24h para responder após receber uma mensagem, de acordo com as políticas do Facebook.",
        defaultMetaMessage: "Olá! Tenho interesse e queria mais informações, por favor.",
      },
      ticketsResponsive: {
        search: {
          searchInMessagesTooltip: "Marque para pesquisar também nos conteúdos das mensagens (mais lento)",
        },
        filter: {
          all: "Todos",
          unreplied: "Não respondidos",
          title: "Filtros",
          queues: "Filas",
          tags: "Tags",
          connections: "Conexões",
          status: "Status",
          users: "Usuários",
          showTags: "Mostrar tags",
          hideTags: "Ocultar tags",
        },
        sort: {
          ascending: "Crescente",
          descending: "Decrescente",
        },
      },
      contactForm: {
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          required: "Obrigatório",
          invalidEmail: "Email inválido",
        },
        placeholders: {
          number: "5513912344321",
          email: "Endereço de email",
        },
      },
      common: {
        image: "imagem",
      },
      transferTicketModal: {
        title: "Transferir Ticket",
        fieldLabel: "Digite para buscar usuários",
        fieldQueueLabel: "Transferir para fila",
        fieldQueuePlaceholder: "Selecione uma fila",
        fieldWhatsapp: "Selecione um whatsapp",
        noOptions: "Nenhum usuário encontrado com esse nome",
        msgTransfer: "Observações - mensagem interna, não vai para o cliente",
        buttons: {
          ok: "Transferir",
          cancel: "Cancelar",
        },
      },
      ticketsList: {
        called: "Chamado",
        today: "Hoje",
        missedCall: "Chamada de voz/vídeo perdida às",
        pendingHeader: "Aguardando",
        assignedHeader: "Atendendo",
        groupingHeader: "Grupos",
        noTicketsTitle: "Nada aqui!",
        noTicketsMessage:
          "Nenhum atendimento encontrado com esse status ou termo pesquisado",
        noQueue: "Sem Fila",
        draft: "Rascunho:",
        buttons: {
          accept: "Aceitar",
          cancel: "Cancelar",
          start: "iniciar",
          closed: "Fechar",
          reopen: "Reabrir",
          transfer: "Transferir",
          ignore: "Ignorar",
          exportAsPDF: "Exportar para PDF",
          kanbanActions: "Opções de Kanban",
          showAll: "Ver Todos",
        },
        acceptModal: {
          title: "Aceitar Chat",
          queue: "Selecionar setor",
        },
      },
      newTicketModal: {
        title: "Criar Ticket",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Salvar",
          cancel: "Cancelar",
        },
        form: {
          contact: "Contato",
          queue: "Fila",
          message: "Mensagem inicial",
          contactPlaceholder: "Buscar contato...",
          queuePlaceholder: "Selecione uma fila...",
          connectionPlaceholder: "Selecione uma Conexão...",
          messagePlaceholder: "Mensagem inicial opcional..."
        },
        validation: {
          contactRequired: "Você deve selecionar um contato",
          queueRequired: "Selecione uma fila"
        }
      },
      SendContactModal: {
        title: "Enviar contato",
        fieldLabel: "Digite para pesquisar o contato",
        add: "Adicionar",
        buttons: {
          ok: "Enviar",
          cancel: "Cancelar",
        },
      },
      mainDrawer: {
        listItems: {
          dashboard: "Dashboard",
          connections: "Conexões",
          chatsTempoReal: "Painel",
          tickets: "Atendimentos",
          quickMessages: "Respostas rápidas",
          contacts: "Contatos",
          queues: "Filas",
          flowbuilder: "Flowbuilder",
          tags: "Tags",
          administration: "Administração",
          companies: "Empresas",
          users: "Usuários",
          settings: "Configurações",
          files: "Lista de arquivos",
          helps: "Ajuda",
          messagesAPI: "API",
          schedules: "Agendamentos",
          campaigns: "Campanhas",
          annoucements: "Informativos",
          announcements: "Informativos",
          knowledgeBase: "Base de Conhecimento",
          agentQualification: "Qualificação do Agente",
          chats: "Chat Interno",
          financeiro: "Financeiro",
          queueIntegration: "Integrações",
          version: "Versão",
          kanban: "Kanban",
          prompts: "Prompts",
          allConnections: "Gerenciar conexões",
          reports: "Relatórios",
          management: "Análise"
        },
        appBar: {
          search: "Buscar...",
          user: {
            profile: "Perfil",
            logout: "Sair",
            message: "Olá",
            messageEnd: "seja bem-vindo a",
            active: "Ativo até",
            goodMorning: "Oi,",
            myName: "meu nome é",
            continuity: "e darei continuidade em seu atendimento.",
            virtualAssistant: "Assistente Virtual",
            token:
              "Token inválido, por favor entre em contato com o administrador da plataforma.",
          },
          message: {
            location: "Localização",
            contact: "Contato",
          },
          notRegister: "Nenhum registro",
          refresh: "Atualizar",
          themeLight: "Modo claro",
          themeDark: "Modo escuro",
          volume: "Volume",
          volumeNotifications: "Volume das notificações",
          installPwa: {
            title: "Adicionar à tela inicial",
            iosStep1: "Toque no botão Compartilhar (ícone de quadrado com seta para cima)",
            iosStep2: "Role e toque em \"Adicionar à Tela de Início\"",
            iosStep3: "Toque em \"Adicionar\"",
            androidStep1: "Toque no menu do navegador ⋮ (três pontinhos do Chrome)",
            androidStep2: "Toque em \"Adicionar à tela inicial\" ou \"Instalar aplicativo\"",
            androidStep3: "Confirme tocando em \"Instalar\"",
            gotIt: "Entendi",
          },
          mobileMenu: {
            title: "Menu",
            language: "Idioma",
            darkMode: "Modo escuro",
            lightMode: "Modo claro",
            volume: "Volume",
            announcements: "Comunicados",
            chat: "Chat",
            addToHomeScreen: "Adicionar à tela inicial",
            understood: "Entendi",
            installIos1: "Toque no botão",
            installIosShare: "Compartilhar",
            installIos1b: "(ícone de quadrado com seta para cima)",
            installIos2: "Role e toque em",
            installIos2b: "Adicionar à Tela de Início",
            installIos3: "Toque em",
            installIos3b: "Adicionar",
            installAndroid1: "Toque no menu do navegador",
            installAndroid1b: "(três pontinhos do Chrome)",
            installAndroid2: "Toque em",
            installAndroid2b: "Adicionar à tela inicial",
            installAndroid2c: "Instalar aplicativo",
            installAndroid3: "Confirme tocando em",
            installAndroid3b: "Instalar",
          },
        },
      },
      languages: {
        undefined: "Idioma",
        "pt-BR": "Português",
        es: "Espanhol",
        en: "Inglês",
        tr: "Turco",
      },
      messagesAPI: {
        title: "API",
        subtitle: "Integre sistemas externos para enviar mensagens via API.",
        methodsSubtitle: "Endpoints disponíveis e regras para o número de destino.",
        textMessage: {
          number: "Número",
          body: "Mensagem",
          token: "Token cadastrado",
          userId: "ID do usuário/atendente",
          queueId: "ID da Fila",
        },
        mediaMessage: {
          number: "Número",
          body: "Nome do arquivo",
          media: "Arquivo",
          token: "Token cadastrado",
        },
        API: {
          title: "Documentação para envio de mensagens",
          methods: {
            title: "Métodos de Envío",
            messagesText: "Mensagens de Texto",
            messagesMidia: "Mensagens de Media",
          },
          instructions: {
            title: "Instruções",
            comments: "Observações Importantes",
            comments1:
              "Antes de enviar mensagens, é necessário o cadastro do token vinculado à conexão que enviará as mensagens. <br />Para realizar o cadastro acesse o menu 'Conexões', clique no botão editar da conexão e insira o token no devido campo.",
            comments2:
              "O número para envio não deve ter mascara ou caracteres especiais e deve ser composto por:",
            codeCountry: "Código do País",
            code: "DDD",
            number: "Número",
          },
          text: {
            title: "1. Mensagens de Texto",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
          media: {
            title: "2. Mensagens de Media",
            instructions:
              "Seguem abaixo a lista de informações necessárias para envio das mensagens de texto:",
          },
        },
        messages: {
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
          success: "Mensagem enviada com sucesso",
        },
        form: {
          send: "Enviar",
          testSend: "Teste de envio",
          chooseFile: "Escolher arquivo",
          noFile: "Nenhum arquivo selecionado",
        },
        documentation: {
          endpoint: "Endpoint: ",
          method: "Método: ",
          post: "POST",
          headers: "Headers: ",
          headersTextAuth: "Authorization Bearer (token registrado) e Content-Type (application/json)",
          headersMediaAuth: "Authorization Bearer (token cadastrado) e Content-Type (multipart/form-data)",
          body: "Body: ",
          formData: "FormData: ",
          bodyExample: "{\n  \"number\": \"558599999999\",\n  \"body\": \"Message\",\n  \"userId\": \"ID usuário ou \\\"\\\"\",\n  \"queueId\": \"ID Fila ou \\\"\\\"\",\n  \"sendSignature\": \"Assinar mensagem - true/false\",\n  \"closeTicket\": \"Encerrar o ticket - true/false\"\n}",
          formDataFields: {
            number: "number: 558599999999",
            body: "body: Message",
            userId: "userId: ID usuário ou \\\"\\\"",
            queueId: "queueId: ID da fila ou \\\"\\\"",
            medias: "medias: arquivo",
            sendSignature: "sendSignature: Assinar mensagem true/false",
            closeTicket: "closeTicket: Encerrar ticket true/false",
          },
        },
      },
      notifications: {
        title: "Notificações",
        noTickets: "Nenhuma notificação.",
        tabs: {
          system: "Sistema",
          chat: "Chat",
          internal: "Interno",
        },
      },
      quickMessages: {
        title: "Respostas rápidas",
        subtitle: "Atalhos para mensagens reutilizáveis no atendimento",
        searchPlaceholder: "Pesquisar...",
        noAttachment: "Sem anexo",
        empty: "Nenhuma resposta rápida cadastrada.",
        global: "Global",
        personal: "Pessoal",
        kpis: {
          total: "Total",
          withMedia: "Com mídia",
          global: "Globais",
          personal: "Pessoais",
        },
        filters: {
          visibility: "Visibilidade",
          all: "Todas",
          mine: "Minhas",
          shared: "Compartilhadas",
        },
        tooltips: {
          edit: "Editar",
          delete: "Excluir",
          removeAttachment: "Remover anexo",
        },
        confirmationModal: {
          deleteTitle: "Exclusão",
          deleteMessage: "Esta ação é irreversível! Deseja prosseguir?",
        },
        buttons: {
          add: "Adicionar",
          attach: "Anexar Arquivo",
          cancel: "Cancelar",
          edit: "Editar",
        },
        toasts: {
          success: "Atalho adicionado com sucesso!",
          deleted: "Atalho removido com sucesso!",
        },
        dialog: {
          title: "Mensagem Rápida",
          shortcode: "Atalho",
          message: "Resposta",
          save: "Salvar",
          cancel: "Cancelar",
          geral: "Permitir editar",
          add: "Adicionar",
          edit: "Editar",
          visao: "Permitir visão",
          allow: "Permitir",
          disallow: "Não permitir",
        },
        table: {
          shortcode: "Atalho",
          message: "Mensagem",
          actions: "Ações",
          mediaName: "Nome do Arquivo",
          status: "Escopo",
          createdBy: "Criado por",
          you: "você",
          emptyMessage: "—",
        },
      },
      contactLists: {
        title: "Listas de Contatos",
        subtitle: "Organize bases de contatos para campanhas.",
        empty: {
          list: "Nenhuma lista cadastrada.",
          search: "Nenhuma lista encontrada para a busca.",
        },
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lista",
          downloadSample: "Baixar Planilha Exemplo",
        },
        dialog: {
          name: "Nome",
          company: "Empresa",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
          description: "Defina um nome para identificar esta base em campanhas e importações.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          deleted: "Registro excluído",
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
      },
      contactListItems: {
        title: "Contatos",
        subtitle: "Gerencie os contatos desta lista.",
        searchPlaceholder: "Pesquisa",
        empty: {
          list: "Nenhum contato cadastrado nesta lista.",
          search: "Nenhum contato encontrado para a busca.",
        },
        buttons: {
          add: "Novo",
          lists: "Listas",
          import: "Importar",
        },
        dialog: {
          name: "Nome",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "E-mail",
          okEdit: "Editar",
          okAdd: "Adicionar",
          add: "Adicionar",
          edit: "Editar",
          cancel: "Cancelar",
          description: "Preencha os dados do contato que fará parte desta lista.",
        },
        table: {
          name: "Nome",
          number: "Número",
          whatsapp: "WhatsApp",
          email: "E-mail",
          actions: "Ações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
          importMessage: "Deseja importar os contatos desta planilha? ",
          importTitlte: "Importar",
        },
        toasts: {
          deleted: "Registro excluído",
        },
        downloadTemplate: "Clique aqui para baixar planilha exemplo.",
        whatsappValid: "Whatsapp Válido",
        whatsappInvalid: "Whatsapp Inválido",
      },
      kanban: {
        title: "Kanban",
        subtitle: "Visualização de tickets em formato Kanban",
        searchPlaceholder: "Pesquisa",
        subMenus: { list: "Painel", tags: "Lanes" },
        ticketNumber: "Ticket nº ",
        viewTicket: "Ver Ticket",
        startDate: "Data de início",
        endDate: "Data de fim",
        search: "Buscar",
        addColumns: "+ Adicionar colunas",
        ticketTagRemoved: "Coluna removida do ticket",
        ticketTagAdded: "Coluna adicionada ao ticket",
        ticketMoveError: "Erro ao mover ticket",
        iconChannelError: "Erro",
        noTickets: "Nenhum ticket",
        emptyBoard: "Quadro vazio — adicione colunas e tickets",
        emptyStateTags: "Nenhuma tag Kanban criada",
        emptyStateTagsDescription: "Crie sua primeira tag Kanban para começar a organizar tickets",
        createFirstTag: "Criar Primeira Tag",
        emptyStateTickets: "Nenhum ticket encontrado",
        emptyStateTicketsDescription: "Ajuste os filtros de data ou crie novos tickets",
        errorTitle: "Erro ao carregar Kanban",
        errorDescription: "Ocorreu um erro ao buscar dados. Tente novamente.",
        retry: "Tentar Novamente",
        template: "Modelo",
        common: { close: "Fechar" },
        addCard: "Adicionar card",
        createFirstColumn: "Criar primeira coluna",
        emptyBoardDescription: "Crie a primeira coluna para começar a organizar seus tickets.",
        addColumn: { before: "Adicionar coluna antes", after: "Adicionar coluna depois", first: "Adicionar primeira coluna", edit: "Editar coluna" },
        laneLock: {
          systemDefaultTooltip: "Coluna padrão do sistema — necessária pro tracking, não pode ser apagada.",
          dealOutcomeTooltipTemplate: "Coluna marcada como etapa de resultado ({{outcome}}). Remova o resultado primeiro pra apagar.",
          mappingTooltipTemplate: "Em uso por mapping(s) de tracking: {{names}}.",
          protectedTooltip: "Coluna protegida.",
          systemDefaultLabel: "Coluna padrão (sistema)",
          dealOutcomeLabel: "Etapa de resultado",
          mappingLabel: "Em uso por mapping",
          protectedLabel: "Coluna protegida",
          dealWon: "Venda ganha",
          dealLost: "Venda perdida"
        },
        budget: {
          fillProductBoth: "Preencha nome e valor do produto",
          fillProductName: "Preencha o nome do produto",
          productLabel: "Produto",
          valueLabel: "Valor",
          total: "Total",
          statuses: {
            approved: "Aprovado",
            budget: "Orçamento",
            cancelled: "Cancelado",
            negotiating: "Negociando",
            overdue: "Atrasado",
            paid: "Pago",
            partial: "Pago parcialmente",
            pending: "Pendente",
            refunded: "Reembolsado",
            rejected: "Rejeitado"
          }
        },
        card: {
          budget: "Orçamentos",
          followUp: "Follow-up",
          notes: "Notas",
          tags: "Tags",
          openChat: "Abrir conversa",
          moveNext: "Mover para próxima",
          noMessages: "Sem mensagens",
          noName: "Sem nome",
          scheduledMessage: "Mensagem agendada",
          menu: "Mais opções",
          editSchedule: "Editar agendamento",
          deleteSchedule: "Excluir agendamento",
          media: {
            audio: "Áudio",
            contact: "Contato",
            document: "Documento",
            image: "Imagem",
            location: "Localização",
            sticker: "Figurinha",
            video: "Vídeo"
          }
        },
        cardMenu: {
          closeTicket: "Fechar ticket",
          contactDetails: "Detalhes do contato",
          deleteLead: "Excluir lead",
          editContact: "Editar contato",
          markLost: "Marcar como Perdido",
          markWon: "Marcar como Ganho",
          moveCard: "Mover card",
          moveToBoard: "Mover para outro quadro",
          mute: "Silenciar",
          transfer: "Transferir",
          unmute: "Reativar som"
        },
        contactDrawer: { title: "Contato" },
        currency: { title: "Moeda", searchPlaceholder: "Buscar moeda" },
        deal: {
          boardOptional: "Quadro destino (opcional)",
          columnOptional: "Coluna destino (opcional)",
          confirm: "Confirmar",
          loadingColumns: "Carregando colunas…",
          lostReason: "Motivo da perda",
          markLost: "Marcar como Perdido",
          markWon: "Marcar como Ganho",
          notesLabel: "Notas",
          selectReason: "Selecione um motivo",
          selectReasonTooltip: "Escolha um motivo para confirmar",
          winReason: "Motivo do ganho"
        },
        deleteBoardDialog: {
          body: "Esta ação não pode ser desfeita. Confirma?",
          titleTemplate: "Excluir quadro \"{{name}}\""
        },
        deleteColumnDialog: {
          columnHasCardsBefore: "Esta coluna tem",
          columnHasCardsAfter: "card(s). Para onde transferi-los?",
          confirmBodyBefore: "Excluir a coluna",
          confirmBodyAfter: "? Esta ação não pode ser desfeita.",
          delete: "Excluir",
          deleteAndTransfer: "Excluir e transferir",
          selectColumnPlaceholder: "Selecione a coluna destino",
          selectDestination: "Coluna destino",
          titleTemplate: "Excluir coluna \"{{name}}\""
        },
        deleteTicket: {
          alsoDeleteContact: "Também excluir o contato",
          body: "Esta ação não pode ser desfeita. Confirma?",
          saveOnly: "Excluir lead",
          saveWithContact: "Excluir lead e contato",
          titleGeneric: "Excluir ticket",
          titleTemplate: "Excluir lead de \"{{name}}\""
        },
        filters: {
          title: "Filtros",
          attendants: "Atendentes",
          connections: "Conexões",
          queues: "Filas",
          status: "Status",
          tags: "Tags",
          unreplied: "Sem resposta",
          clearAll: "Limpar filtros",
          apply: "Aplicar",
          tabs: { all: "Todos", group: "Grupos", open: "Abertos", pending: "Pendentes" }
        },
        followUp: {
          fillDiscussedTooltip: "Descreva o que foi tratado",
          nextReturnLabel: "Próximo retorno",
          past: "Anteriores",
          registerButton: "Registrar follow-up",
          timeLabel: "Horário",
          title: "Follow-ups",
          upcoming: "Próximos",
          whatWasDiscussedLabel: "O que foi discutido"
        },
        laneMenu: {
          addAfter: "Adicionar coluna depois",
          addBefore: "Adicionar coluna antes",
          addCard: "Adicionar card",
          deleteColumn: "Excluir coluna",
          edit: "Editar coluna",
          rename: "Renomear"
        },
        leadSource: { indicacao: "Indicação" },
        moveBoard: {
          board: "Quadro",
          column: "Coluna",
          loadingColumns: "Carregando colunas…",
          move: "Mover",
          title: "Mover para outro quadro"
        },
        newBoard: {
          nameLabel: "Nome do quadro",
          save: "Salvar",
          saving: "Salvando…",
          selectBoardPlaceholder: "Selecione um quadro",
          templateEmpty: "Em branco",
          templatePostSales: "Pós-vendas",
          title: "Novo quadro"
        },
        notes: { newLabel: "Nova nota", typePlaceholder: "Digite uma nota e pressione Enter" },
        schedule: { newScheduled: "Nova mensagem agendada", noBody: "Sem texto", title: "Agendamentos" },
        toasts: {
          boardDeleted: "Quadro excluído",
          transferCardsBeforeDelete: "Transfira os cards antes de excluir o quadro"
        },
        tooltips: {
          deleteBoard: "Excluir quadro",
          enterFullscreen: "Tela cheia",
          exitFullscreen: "Sair da tela cheia",
          newBoard: "Novo quadro",
          sortAsc: "Ordenar crescente",
          sortDesc: "Ordenar decrescente",
          viewAll: "Ver todos",
          viewOnlyMine: "Ver apenas meus"
        }
      },
      campaigns: {
        title: "Campanhas",
        subtitle: "Crie e acompanhe envios programados para listas de contatos.",
        searchPlaceholder: "Pesquisa",
        empty: {
          list: "Nenhuma campanha cadastrada.",
          search: "Nenhuma campanha encontrada para a busca.",
        },
        subMenus: {
          list: "Listagem",
          listContacts: "Lista de contatos",
          settings: "Configurações",
        },
        status: {
          inactive: "Inativa",
          scheduled: "Programada",
          inProgress: "Em Andamento",
          cancelled: "Cancelada",
          finished: "Finalizada",
        },
        common: {
          none: "Nenhuma",
          notDefined: "Não definida",
          noSchedule: "Sem agendamento",
          notCompleted: "Não concluída",
          enabled: "Habilitada",
          disabled: "Desabilitada",
        },
        modal: {
          tabLabels: {
            msg1: "Msg. 1",
            msg2: "Msg. 2",
            msg3: "Msg. 3",
            msg4: "Msg. 4",
            msg5: "Msg. 5",
          },
          helpText: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
        },
        settings: {
          randomInterval: "Intervalo Randômico de Disparo",
          noBreak: "Sem Intervalo",
          intervalGapAfter: "Intervalo maior após",
          undefined: "Não definido",
          messages: "mensagens",
          laggerTriggerRange: "Intervalo de disparo maior",
          addVar: "Adicionar variável",
          save: "Salvar",
          close: "Fechar",
          add: "Adicionar",
          shortcut: "Atalho",
          content: "Conteúdo",
        },
        buttons: {
          add: "Nova Campanha",
          contactLists: "Listas de Contatos",
          stopCampaign: "Parar Campanha",
          restartCampaign: "Reiniciar campanha",
          report: "Relatório",
        },
        table: {
          name: "Nome",
          whatsapp: "Conexão",
          contactList: "Lista de Contatos",
          option: "Nenhuma",
          disabled: "Desabilitada",
          enabled: "Habilitada",
          status: "Status",
          scheduledAt: "Agendamento",
          completedAt: "Concluída",
          confirmation: "Confirmação",
          actions: "Ações",
        },
        dialog: {
          new: "Nova Campanha",
          update: "Editar Campanha",
          readonly: "Apenas Visualização",
          help: "Utilize variáveis como {nome}, {numero}, {email} ou defina variáveis personalizadas.",
          form: {
            name: "Nome",
            message1: "Mensagem 1",
            message2: "Mensagem 2",
            message3: "Mensagem 3",
            message4: "Mensagem 4",
            message5: "Mensagem 5",
            confirmationMessage1: "Mensagem de Confirmação 1",
            confirmationMessage2: "Mensagem de Confirmação 2",
            confirmationMessage3: "Mensagem de Confirmação 3",
            confirmationMessage4: "Mensagem de Confirmação 4",
            confirmationMessage5: "Mensagem de Confirmação 5",
            messagePlaceholder: "Conteúdo da mensagem",
            whatsapp: "Conexão",
            status: "Status",
            scheduledAt: "Agendamento",
            confirmation: "Confirmação",
            contactList: "Lista de Contato",
            tagList: "Tags",
            statusTicket: "Status do Ticket",
            openTicketStatus: "Aberto",
            pendingTicketStatus: "Pendente",
            closedTicketStatus: "Fechado",
            enabledOpenTicket: "Habilitado",
            disabledOpenTicket: "Desabilitado",
            openTicket: "Abrir ticket",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar Disparos",
            restart: "Reiniciar Disparos",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          cancel: "Campanha cancelada",
          restart: "Campanha reiniciada",
          deleted: "Registro excluído",
        },
        noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
      },
      campaignReport: {
        title: "Relatório de",
        subtitle: "Acompanhe o andamento e os resultados da campanha",
        inactive: "Inativa",
        scheduled: "Programada",
        process: "Em Andamento",
        cancelled: "Cancelada",
        finished: "Finalizada",
        campaign: "Campanha",
        validContacts: "Contatos Válidos",
        confirmationsRequested: "Confirmações Solicitadas",
        confirmations: "Confirmações",
        deliver: "Entregues",
        connection: "Conexão",
        contactLists: "Lista de Contatos",
        schedule: "Agendamento",
        conclusion: "Conclusão",
        noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        status: "Status:",
        of: "de",
      },
      announcements: {
        title: "Informativos",
        subtitle: "Gerencie informativos enviados aos usuários da plataforma",
        searchPlaceholder: "Pesquisa",
        active: "Ativo",
        inactive: "Inativo",
        empty: {
          search: "Nenhum informativo corresponde à busca.",
          list: "Nenhum informativo cadastrado.",
        },
        buttons: {
          add: "Novo Informativo",
          contactLists: "Listas de Informativos",
        },
        table: {
          priority: "Prioridade",
          title: "Título",
          text: "Texto",
          mediaName: "Arquivo",
          status: "Status",
          actions: "Ações",
        },
        dialog: {
          edit: "Edição de Informativo",
          add: "Novo Informativo",
          update: "Editar Informativo",
          readonly: "Apenas Visualização",
          subtitle: "Defina o título, conteúdo, status e prioridade do informativo exibido aos usuários.",
          form: {
            priority: "Prioridade",
            title: "Título",
            text: "Texto",
            mediaPath: "Arquivo",
            status: "Status",
            high: "Alta",
            medium: "Média",
            low: "Baixa",
            active: "Ativo",
            inactive: "Inativo",
          },
          buttons: {
            add: "Adicionar",
            edit: "Atualizar",
            okadd: "Ok",
            cancel: "Cancelar",
            close: "Fechar",
            attach: "Anexar Arquivo",
          },
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        toasts: {
          success: "Operação realizada com sucesso",
          deleted: "Registro excluído",
        },
      },
      campaignsConfig: {
        title: "Configurações de Campanhas",
        noPermissionMessage: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        settingsSaved: "Configurações salvas",
        intervals: "Intervalos",
        intervalDescription: "Defina os intervalos usados no envio automático das campanhas.",
        seconds: "segundos",
      },
      campaignsPhrase: {
        title: "Campanhas",
        subtitle: "Gerencie campanhas acionadas por frases",
        phraseDeleted: "Frase deletada",
        phraseUpdated: "Frase alterada com sucesso!",
        phraseCreated: "Frase criada com sucesso!",
        addCampaign: "Campanha",
        table: {
          name: "Nome",
          status: "Status",
          active: "Ativo",
          inactive: "Desativado",
          empty: "Nenhuma campanha por frase encontrada",
          emptySearch: "Nenhuma campanha corresponde à busca.",
        },
        modal: {
          editTitle: "Editar campanha com fluxo por frase",
          newTitle: "Nova campanha com fluxo por frase",
          nameLabel: "Nome do disparo por frase",
          flowLabel: "Escolha um fluxo",
          flowPlaceholder: "Escolha um fluxo",
          connectionPlaceholder: "Selecione uma Conexão",
          phraseLabel: "Qual frase dispara o fluxo?",
          matchTypeLabel: "Tipo de correspondência",
          matchTypeExact: "Correspondência Exata",
          matchTypeContains: "Contém a palavra",
          matchTypeTooltip: "Exata: mensagem deve ser igual à palavra. Contém: palavra pode aparecer em qualquer parte da mensagem",
          statusLabel: "Status",
          cancelButton: "Cancelar",
          saveButton: "Salvar campanha",
          createButton: "Criar campanha",
        },
      },
      queues: {
        title: "Filas",
        subtitle: "Departamentos para organizar e distribuir os tickets entre os atendentes",
        empty: "Nenhuma fila cadastrada.",
        table: {
          name: "Nome",
          color: "Cor",
          greeting: "Mensagem de saudação",
          orderQueue: "Ordenação da fila (bot)",
          actions: "Ações",
          ID: "ID",
        },
        buttons: {
          add: "Adicionar fila",
          edit: "Editar",
          delete: "Excluir",
        },
        toasts: {
          success: "Fila salva com sucesso",
          deleted: "Fila excluída com sucesso",
          queueDeleted: "Fila excluída com sucesso!",
          botSaved: "Bot salvo com sucesso",
          clickToSave: "Clique em salvar para registrar as alterações",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! Os atendimentos dessa fila continuarão existindo, mas não terão mais nenhuma fila atribuída.",
        },
      },
      queue: {
        queueData: "Dados",
      },
      queueSelect: {
        inputLabel: "Filas",
        inputLabelRO: "Filas somente leitura",
        withoutQueue: "Sem fila",
        undefined: "Fila não encontrada",
        errors: {
          loadError: "QUEUESELETSINGLE >>>"
        }
      },
      queueIntegration: {
        title: "Integrações",
        subtitle: "Conecte fluxos automatizados externos como N8N e Typebot",
        empty: "Nenhuma integração cadastrada.",
        table: {
          id: "ID",
          type: "Tipo",
          name: "Nome",
          projectName: "Nome do Projeto",
          language: "Linguagem",
          lastUpdate: "Ultima atualização",
          actions: "Ações",
        },
        buttons: {
          add: "Adicionar Projeto",
          edit: "Editar",
          delete: "Excluir",
        },
        searchPlaceholder: "Pesquisar...",
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Você tem certeza? Essa ação não pode ser revertida! e será removida das filas e conexões vinculadas",
        },
        toasts: {
          deleted: "Integração deletada com sucesso!",
        },
        messages: {
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
      },
      users: {
        title: "Usuários",
        subtitle: "Gerencie os atendentes, perfis e permissões da sua equipe",
        empty: "Nenhum usuário cadastrado.",
        table: {
          status: "Status",
          avatar: "Avatar",
          name: "Nome",
          email: "Email",
          profile: "Perfil",
          startWork: "Início de trabalho",
          endWork: "Fim de trabalho",
          actions: "Ações",
          ID: "ID",
        },
        profile: {
          admin: "Admin",
          user: "Usuário",
        },
        status: {
          enabled: "Habilitado",
          disabled: "Desabilitado",
        },
        upload: {
          avatar: "Enviar Avatar",
        },
        buttons: {
          add: "Adicionar usuário",
          edit: "Editar",
          delete: "Excluir",
        },
        toasts: {
          deleted: "Usuário excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados do usuário serão perdidos. Os atendimentos abertos deste usuário serão movidos para a fila.",
        },
      },
      compaies: {
        title: "Empresas",
        subtitle: "Gerencie todas as empresas (tenants) da plataforma",
        actions: {
          new: "Nova empresa",
        },
        modal: {
          createTitle: "Nova empresa",
          editTitle: "Editar empresa",
          cancel: "Cancelar",
          incrementDueDate: "Avançar vencimento conforme recorrência",
        },
        empty: {
          list: "Nenhuma empresa cadastrada.",
          search: "Nenhuma empresa corresponde à busca.",
        },
        due: {
          expired: "Vencida",
        },
        form: {
          documentLabel: "CPF/CNPJ (opcional)",
          documentPlaceholder: "000.000.000-00 ou 00.000.000/0000-00",
          documentInvalid: "CPF/CNPJ inválido",
          documentDuplicate: "CPF/CNPJ já cadastrado no sistema",
          documentNotProvided: "Não informado",
          nameRequired: "Nome é obrigatório",
          emailRequired: "E-mail é obrigatório",
        },
        table: {
          ID: "ID",
          status: "Ativo",
          name: "Nome",
          email: "Email",
          password: "Senha",
          phone: "Telefone",
          plan: "Plano",
          active: "Ativo",
          numberAttendants: "Atendentes",
          numberConections: "Conexões",
          value: "Valor",
          namePlan: "Nome Plano",
          numberQueues: "Filas",
          useCampaigns: "Campanhas",
          useExternalApi: "Rest API",
          useFacebook: "Facebook",
          useInstagram: "Instagram",
          useWhatsapp: "Whatsapp",
          useInternalChat: "Chat Interno",
          useSchedules: "Agendamento",
          createdAt: "Criada Em",
          dueDate: "Vencimento",
          lastLogin: "Ult. Login",
          actions: "Ações",
          money: "R$",
          yes: "Sim",
          no: "Não",
          folderSize: "Tamanho da pasta",
          totalFiles: "Total de arquivos",
          lastUpdate: "Ultimo update",
          document: "CNPJ/CPF",
          recurrence: "Recorrência",
          monthly: "Mensal",
          bimonthly: "Bimestral",
          quarterly: "Trimestral",
          semester: "Semestral",
          yearly: "Anual",
          clear: "Limpar",
          delete: "Excluir",
          user: "Usuário",
          save: "Salvar",
        },
        searchPlaceholder: "Buscar empresas...",
        searchLabel: "Campo de busca de empresas",
        clearSearch: "Limpar busca",
        buttons: {
          add: "Adicionar empresa",
        },
        toasts: {
          deleted: "Empresa excluído com sucesso.",
        },
        confirmationModal: {
          deleteTitle: "Excluir",
          deleteMessage:
            "Todos os dados da empresa serão perdidos. Os tickets abertos deste usuário serão movidos para a fila.",
        },
        notifications: {
          noPermission: "Esta empresa não possui permissão para acessar essa página! Estamos lhe redirecionando.",
        },
      },
      plans: {
        title: "Planos",
        subtitle: "Gerencie os planos disponíveis na plataforma",
        actions: {
          new: "Novo plano",
        },
        empty: {
          search: "Nenhum plano corresponde à busca.",
          list: "Nenhum plano cadastrado.",
        },
        table: {
          actions: "Ações",
        },
        modal: {
          createTitle: "Novo plano",
          editTitle: "Editar plano",
          cancel: "Cancelar",
          billingType: "Tipo de cobrança",
          billingTypes: {
            single: "Único",
            recurring: "Recorrente",
            free: "Grátis",
          },
          recurrence: "Recorrência",
          recurrences: {
            weekly: "Semanal",
            biweekly: "Quinzenal",
            monthly: "Mensal",
            quarterly: "Trimestral",
            semiannual: "Semestral",
            annual: "Anual",
          },
          resources: "Recursos",
          markAll: "Marcar todos",
          unmarkAll: "Desmarcar todos",
        },
        form: {
          name: "Nome",
          users: "Usuários",
          connections: "Conexões",
          campaigns: "Campanhas",
          schedules: "Agendamentos",
          enabled: "Habilitadas",
          disabled: "Desabilitadas",
          clear: "Cancelar",
          delete: "Excluir",
          save: "Salvar",
          yes: "Sim",
          no: "Não",
          money: "R$",
          public: "Público"
        },
      },
      helps: {
        title: "Central de Ajuda",
        subtitle: "Cadastre vídeos do YouTube exibidos na Central de Ajuda dos usuários.",
        thumbnail: "Miniatura",
        videoPlayerTitle: "Player de vídeo do YouTube",
        settings: {
          codeVideo: "Código do Vídeo",
          description: "Descrição",
          clear: "Limpar",
          delete: "Excluir",
          save: "Salvar",
        },
        form: {
          newTitle: "Cadastrar novo vídeo",
          editTitle: "Editar vídeo",
          titleLabel: "Título",
          titlePlaceholder: "Ex: Como configurar o WhatsApp",
          linkLabel: "Link do YouTube",
          linkPlaceholder: "https://www.youtube.com/watch?v=...",
          descriptionLabel: "Descrição",
          descriptionPlaceholder: "Resumo curto sobre o que o vídeo ensina",
          invalidLink: "Link inválido. Cole a URL completa do YouTube.",
        },
        table: {
          title: "Título",
          description: "Descrição",
          video: "Vídeo",
          actions: "Ações",
        },
        empty: {
          list: "Nenhum vídeo cadastrado ainda.",
          search: "Nenhum vídeo encontrado para a busca.",
        },
        tooltips: {
          title: {
            description: "Nome curto e direto que o usuário vai ver no card da Central de Ajuda.",
            steps: [
              "Use 5 a 8 palavras descrevendo o tema (ex: \"Como criar um fluxo no FlowBuilder\").",
              "Evite jargão interno — quem assiste é o usuário final.",
              "O título aparece em destaque acima da descrição no card.",
            ],
          },
          link: {
            description: "Link completo do vídeo no YouTube. O sistema extrai automaticamente o código do vídeo.",
            steps: [
              "Abra o vídeo no YouTube e copie a URL da barra de endereço.",
              "Aceita formatos: youtube.com/watch?v=ID, youtu.be/ID, youtube.com/embed/ID e youtube.com/shorts/ID.",
              "Se preferir, cole apenas o ID do vídeo (11 caracteres).",
              "Confirme que o vídeo está como \"Público\" ou \"Não listado\" — vídeos privados não tocam embutidos.",
            ],
          },
          description: {
            description: "Texto auxiliar exibido abaixo do título no card de ajuda.",
            steps: [
              "Use 1–2 frases explicando o que o usuário vai aprender.",
              "Limite ~120 caracteres — o card corta o excedente em 3 linhas.",
              "Opcional, mas recomendado para melhorar a navegação.",
            ],
          },
        },
      },
      calendarReminder: {
        startsIn: "começa em",
        permissionDenied: "Notificações bloqueadas. Habilite no navegador pra receber lembretes.",
      },
      eventPopover: {
        dateInPast: "A data e hora selecionadas estão no passado.",
        titleNew: "Nova agenda",
        titleEdit: "Editar agenda",
        fields: {
          titleLabel: "Título",
          titlePlaceholder: "Ex: Reunião com cliente",
          eventTypeLabel: "Tipo",
          dateLabel: "Data",
          allDay: "Dia inteiro",
          startTimeLabel: "Início",
          timeLabel: "Horário",
          durationLabel: "Duração",
          reminderLabel: "Lembrete",
          locationLabel: "Local",
          locationPlaceholder: "Ex: Sala 1, Google Meet",
          descriptionLabel: "Descrição",
          descriptionPlaceholder: "Notas, agenda, links…",
        },
        eventTypes: { meeting: "Reunião", task: "Tarefa" },
        durations: {
          min15: "15 minutos", min30: "30 minutos",
          hour1: "1 hora", hour1h30: "1h30", hour2: "2 horas",
          hour3: "3 horas", hour4: "4 horas", hour8: "8 horas",
        },
        reminders: {
          none: "Sem lembrete", min5: "5 minutos antes", min10: "10 minutos antes",
          min15: "15 minutos antes", min30: "30 minutos antes",
          hour1: "1 hora antes", hour2: "2 horas antes", day1: "1 dia antes",
        },
        reminderHint: "Você será lembrado {{when}}",
        buttons: { create: "Criar", save: "Salvar" },
      },
      eventDetailPopover: {
        title: "Agenda",
        edit: "Editar",
        delete: "Excluir",
        allDay: "Dia inteiro",
        createdBy: "Criado por",
        eventTypes: { meeting: "Reunião", task: "Tarefa" },
        reminders: {
          minBefore: "{{count}} minutos antes",
          none: "Sem lembrete", min5: "5 min antes", min10: "10 min antes",
          min15: "15 min antes", min30: "30 min antes",
          hour1: "1 hora antes", hour2: "2 horas antes", day1: "1 dia antes",
        },
      },
      schedules: {
        title: "Agendamentos",
        subtitleCount: "mensagens agendadas",
        subtitleEvents: "agendas",
        calendar: {
          today: "Hoje",
          viewModes: {
            month: "Mês",
            week: "Semana",
            day: "Dia",
            year: "Ano",
            schedule: "Agenda",
          },
        },
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir este Agendamento?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          contact: "Contato",
          body: "Mensagem",
          sendAt: "Data de Agendamento",
          sentAt: "Data de Envio",
          status: "Status",
          actions: "Ações",
        },
        buttons: {
          add: "Nova mensagem agendada",
          addShort: "+ Mensagem",
          addEvent: "Criar agenda",
          addEventShort: "+ Agenda",
        },
        toasts: {
          deleted: "Agendamento excluído com sucesso.",
          eventCreated: "Agenda criada com sucesso.",
          eventUpdated: "Agenda atualizada com sucesso.",
          eventDeleted: "Agenda excluída com sucesso.",
        },
      },
      tags: {
        title: "Tags",
        subtitle: "Organize seus contatos com etiquetas coloridas",
        empty: "Nenhuma tag cadastrada.",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Tag?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          id: "ID",
          name: "Nome",
          kanban: "Kanban",
          color: "Cor",
          tickets: "Registros Tags",
          contacts: "contatos",
          contact: "contato",
          actions: "Ações",
        },
        kpis: {
          total: "Total de tags",
          totalContacts: "Contatos taggeados",
          withContacts: "Tags em uso",
        },
        tooltips: {
          edit: "Editar",
          delete: "Excluir",
          viewContacts: "Ver contatos",
        },
        buttons: {
          add: "Nova Tag",
        },
        toasts: {
          deleted: "Tag excluída com sucesso.",
        },
      },
      tagsKanban: {
        title: "Lanes",
        laneDefault: "Em aberto",
        confirmationModal: {
          deleteTitle: "Você tem certeza que quer excluir esta Lane?",
          deleteMessage: "Esta ação não pode ser revertida.",
        },
        table: {
          name: "Nome",
          color: "Cor",
          tickets: "Tickets",
          actions: "Ações",
        },
        buttons: {
          add: "Nova Lane",
          backToKanban: "Voltar para o Kanban",
        },
        toasts: {
          deleted: "Lane excluída com sucesso.",
        },
      },
      files: {
        title: "Lista de arquivos",
        table: {
          name: "Nome",
          contacts: "Contatos",
          actions: "Ação",
        },
        toasts: {
          deleted: "Lista excluída com sucesso!",
          deletedAll: "Todas as listas foram excluídas com sucesso!",
        },
        buttons: {
          add: "Adicionar",
          deleteAll: "Deletar Todos",
        },
        confirmationModal: {
          deleteTitle: "Deletar",
          deleteAllTitle: "Deletar Todos",
          deleteMessage: "Tem certeza que deseja deletar esta lista?",
          deleteAllMessage: "Tem certeza que deseja deletar todas as listas?",
        },
      },
      settings: {
        success: "Configurações salvas com sucesso.",
        currency: "Moeda",
        title: "Configurações",
        tabs: {
          options: "Geral",
          schedules: "Horários",
          companies: "Empresas",
          plans: "Planos",
          helps: "Ajuda",
          whitelabel: "Whitelabel",
          timezone: "Fuso Horário",
          smtp: "Email / SMTP",
          meta: "Meta",
        },
        helps: {
          systemCurrency: {
            description: "Define a moeda exibida nos cards do Kanban e em todos os campos de valor do sistema.",
            steps: [
              "Selecione a moeda no menu suspenso.",
              "A mudança é sincronizada em tempo real para todos os usuários.",
              "Afeta cards do Kanban, campanhas e relatórios financeiros.",
            ],
          },
          userCreation: {
            description: "Permite que novos usuários se cadastrem na plataforma.",
            steps: [
              "Habilite para liberar o cadastro público em /signup.",
              "Desabilite para ter controle total do acesso.",
            ],
          },
          userRating: {
            description: "Solicita avaliação do atendimento ao final do ticket.",
            steps: [
              "Ative para enviar pesquisa de satisfação ao fechar o ticket.",
              "O cliente responde com nota de 1 a 5.",
              "Os dados aparecem nos relatórios de qualidade.",
            ],
          },
          officeScheduling: {
            description: "Define de onde o sistema vai ler os horários de expediente.",
            steps: [
              "Desabilitado: o sistema não bloqueia atendimento por horário.",
              "Fila: usa os horários configurados em cada fila.",
              "Empresa: usa o horário geral da empresa nesta tela.",
              "Conexão: usa o horário configurado em cada conexão WhatsApp.",
            ],
          },
          sendGreetingAccepted: {
            description: "Envia mensagem ao cliente quando o operador aceita o ticket.",
            steps: [
              "Ative para iniciar com saudação automática.",
              "Personalize o texto no campo que aparece abaixo.",
              "O cliente recebe assim que o operador clica em Aceitar.",
            ],
          },
          userRandom: {
            description: "Distribui tickets aleatoriamente entre operadores online.",
            steps: [
              "Ative para balancear a carga de atendimento.",
              "Apenas operadores online recebem distribuição.",
            ],
          },
          sendMsgTransfTicket: {
            description: "Envia mensagem ao cliente ao transferir o ticket de fila.",
            steps: [
              "Ative para informar a transferência ao cliente.",
              "Use ${queue.name} para incluir o nome da nova fila.",
              "Personalize a mensagem no campo abaixo.",
            ],
          },
          acceptCallWhatsapp: {
            description: "Define se o WhatsApp aceita ligações de voz/vídeo dos clientes.",
            steps: [
              "Desative para enviar mensagem automática quando o cliente ligar.",
              "Configure a mensagem no campo que aparece abaixo.",
              "Útil para informar que não atende por chamada.",
            ],
          },
          sendSignMessage: {
            description: "Permite que o operador envie sua assinatura junto da mensagem.",
            steps: [
              "Ative para mostrar o botão de assinatura no chat.",
              "Cada operador define a própria assinatura no perfil.",
            ],
          },
          sendGreetingMessageOneQueues: {
            description: "Envia saudação mesmo quando há apenas uma fila configurada.",
            steps: [
              "Por padrão, com 1 fila a saudação é pulada.",
              "Ative para sempre enviar a saudação configurada na fila.",
            ],
          },
          sendQueuePosition: {
            description: "Informa ao cliente sua posição atual na fila de atendimento.",
            steps: [
              "Ative para dar transparência sobre o tempo de espera.",
              "Use ${pos} para incluir a posição na mensagem.",
              "Personalize o texto no campo abaixo.",
            ],
          },
          sendFarewellWaitingTicket: {
            description: "Controla se o sistema envia uma despedida quando alguém fecha um ticket que ainda está em Aguardando.",
            steps: [
              "Não envia mensagem ao colocar o ticket em Aguardando.",
              "Só envia quando o ticket já está em Aguardando e é fechado.",
              "A mensagem enviada é a Mensagem de despedida do atendente responsável.",
              "Se o atendente não tiver mensagem de despedida, usa a mensagem de conclusão da conexão WhatsApp.",
              "Não existe configuração dessa mensagem na fila.",
            ],
          },
          acceptAudioMessageContact: {
            description: "Define se o sistema aceita áudios enviados pelo cliente.",
            steps: [
              "Desative para bloquear o recebimento de áudios.",
              "Texto e mídia continuam funcionando normalmente.",
            ],
          },
          enableLGPD: {
            description: "Habilita controles de proteção de dados (LGPD/GDPR).",
            steps: [
              "Ative para mostrar avisos de privacidade ao cliente.",
              "Configure a mensagem de boas-vindas e o link da política.",
              "Use as opções abaixo para ofuscar dados sensíveis.",
            ],
          },
          requiredTag: {
            description: "Exige pelo menos uma tag no ticket antes de fechar.",
            steps: [
              "Ative para garantir categorização dos atendimentos.",
              "Operadores não fecharão tickets sem tag.",
              "Cadastre as tags em \"Tags\" no menu lateral.",
            ],
          },
          closeTicketOnTransfer: {
            description: "Fecha o ticket atual ao transferir para outro setor.",
            steps: [
              "Ative para criar um novo ticket no setor de destino.",
              "O histórico é preservado em ambos os tickets.",
              "Útil para separar atendimentos por departamento.",
            ],
          },
          showNotificationPending: {
            description: "Mostra notificação visual de tickets pendentes.",
            steps: [
              "Ative para alertar sobre tickets aguardando atendimento.",
              "Notificações aparecem no canto superior direito.",
            ],
          },
          autoTranslate: {
            description: "Traduz automaticamente mensagens usando IA.",
            steps: [
              "Ative e cole sua API Key da OpenAI no campo abaixo.",
              "Mensagens são traduzidas para o idioma do operador.",
              "Custos de uso são cobrados pela OpenAI por tokens.",
            ],
          },
          aiAutoSummary: {
            description: "Gera resumos diários automáticos dos tickets usando IA.",
            steps: [
              "Ative para receber resumo do que foi atendido no dia.",
              "Defina o horário em que o resumo será gerado.",
              "Cobre todos os tickets abertos no dia.",
            ],
          },
          sendWelcomeMessage: {
            description: "Envia mensagem de boas-vindas ao cadastrar nova empresa.",
            steps: [
              "Ative para automatizar o onboarding de novos clientes.",
              "Personalize o template com variáveis como {name}, {companyName}.",
              "Variáveis disponíveis: {email}, {phone}, {trialDate}.",
            ],
          },
          flowbuilderAI: {
            description: "Habilita \"Saída IA\" nos blocos do FlowBuilder.",
            steps: [
              "Ative para usar IA quando o tempo de resposta expira.",
              "Cole sua API Key da OpenAI no campo abaixo.",
              "A IA lê o histórico e assume o atendimento automaticamente.",
            ],
          },
          greetingAcceptedMessage: {
            description: "Texto enviado automaticamente quando um operador aceita o ticket.",
            steps: [
              "Escreva uma saudação curta e humana.",
              "Use para avisar que o atendimento começou.",
              "Evite prometer prazo se sua operação não garante resposta imediata.",
            ],
          },
          transferMessage: {
            description: "Texto enviado quando o ticket é transferido para outra fila.",
            steps: [
              "Explique que o atendimento foi encaminhado para outro setor.",
              "Use ${queue.name} para mostrar o nome da nova fila.",
              "Mantenha a mensagem clara para o cliente não achar que foi abandonado.",
            ],
          },
          AcceptCallWhatsappMessage: {
            description: "Texto enviado quando o cliente tenta ligar pelo WhatsApp e chamadas não são aceitas.",
            steps: [
              "Explique que o atendimento é feito por mensagem.",
              "Oriente o cliente a escrever a solicitação no chat.",
              "Use tom educado para reduzir frustração.",
            ],
          },
          sendQueuePositionMessage: {
            description: "Texto que informa ao cliente a posição dele na fila.",
            steps: [
              "Use ${pos} para inserir a posição atual automaticamente.",
              "Informe que ele deve aguardar atendimento.",
              "Evite colocar tempo exato se a fila varia muito.",
            ],
          },
          lgpdMessage: {
            description: "Mensagem de aviso de privacidade enviada ao contato.",
            steps: [
              "Explique de forma simples que dados serão usados no atendimento.",
              "Inclua orientação para aceitar ou continuar.",
              "Use linguagem compatível com sua política de privacidade.",
            ],
          },
          lgpdDeleteMessage: {
            description: "Ofusca o conteúdo de mensagens deletadas pelo contato.",
            steps: [
              "Ative para ocultar mensagens deletadas pelo cliente.",
              "Desative para manter o conteúdo original visível.",
              "Recomendado para conformidade com a LGPD.",
            ],
          },
          lgpdConsent: {
            description: "Solicita consentimento explícito do contato sobre coleta de dados.",
            steps: [
              "Ative para enviar termo de consentimento no primeiro contato.",
              "O cliente precisa aceitar antes de continuar.",
              "Obrigatório em fluxos sensíveis pela LGPD.",
            ],
          },
          lgpdHideNumber: {
            description: "Ofusca o número de telefone do contato para outros usuários.",
            steps: [
              "Ative para esconder o número de operadores não autorizados.",
              "Apenas administradores veem o número completo.",
              "Recomendado para compliance com privacidade.",
            ],
          },
        },
        smtp: {
          title: "Configurações de Email (SMTP)",
          subtitle: "Configure o servidor SMTP para envio de e-mails de recuperação de senha e notificações.",
          preset: "Provedor de Email",
          presetCustom: "Personalizado",
          host: "Servidor SMTP",
          port: "Porta",
          user: "Usuário / Email",
          userPlaceholder: "seuemail@seudominio.com",
          password: "Senha",
          from: "E-mail Remetente",
          fromHelper: "Se vazio, será usado o e-mail do usuário SMTP",
          fromPlaceholder: "noreply@seudominio.com",
          secure: "Segurança",
          secureSslOption: "SSL/TLS (porta 465)",
          secureStarttlsOption: "STARTTLS (porta 587)",
          sendgridUserLabel: "Usuário (fixo: apikey)",
          sendgridUserHelper: "SendGrid usa 'apikey' como usuário fixo",
          sendgridPasswordLabel: "API Key",
          sendgridFromHelper: "Obrigatório: use um remetente verificado no SendGrid",
          save: "Salvar Configurações",
          testConnection: "Testar Conexão",
          sendTestTitle: "Enviar E-mail de Teste",
          sendTestSubtitle: "Envie um e-mail de teste para confirmar que a configuração SMTP está funcionando.",
          testEmailLabel: "E-mail de destino",
          testEmailPlaceholder: "teste@email.com",
          sendTest: "Enviar Teste",
          fillRequired: "Preencha Host, Usuário e Senha.",
          fillTestEmail: "Preencha o e-mail de destino.",
          saveSuccess: "Configurações SMTP salvas com sucesso!",
          saveError: "Erro ao salvar configurações SMTP.",
          testError: "Erro ao testar conexão SMTP.",
          sendTestError: "Erro ao enviar e-mail de teste.",
          fieldHelps: {
            preset: "Escolha seu provedor de e-mail. Se ele aparecer na lista, o sistema preenche servidor, porta e segurança para você. Use Personalizado quando seu provedor não estiver na lista.",
            host: "Cole aqui o endereço do servidor SMTP informado pelo seu provedor de e-mail. Exemplos: smtp.hostinger.com, smtp.gmail.com, smtp.sendgrid.net.",
            port: "Digite a porta indicada pelo provedor. Na maioria dos casos use 465 com SSL/TLS ou 587 com STARTTLS.",
            user: "Informe o login da conta de e-mail que vai enviar as mensagens. Normalmente é o próprio e-mail completo, como contato@seudominio.com.",
            password: "Digite a senha SMTP da conta. Em Gmail, Outlook e outros provedores com verificação em duas etapas, normalmente precisa ser uma senha de app, não a senha normal de login.",
            sendgridPassword: "Cole a API Key criada no SendGrid. Não use a senha da sua conta SendGrid.",
            from: "E-mail que aparecerá como remetente para quem receber a mensagem. Se deixar vazio, o sistema usa o Usuário / Email acima.",
            secure: "Escolha o tipo de segurança que combina com a porta. Porta 465 costuma usar SSL/TLS. Porta 587 costuma usar STARTTLS.",
            testEmail: "Digite um e-mail seu ou de alguém da equipe para receber o teste. Assim você confirma se o envio está funcionando.",
          },
          helps: {
            serverConfig: {
              description: "Configura o servidor SMTP usado para enviar e-mails do sistema (recuperação de senha, notificações, convites).",
              steps: [
                "Escolha um provedor pronto (Hostinger, Gmail, SendGrid, Outlook) ou \"Personalizado\".",
                "Preencha Host, Porta, Usuário (e-mail da conta) e Senha (ou senha de app).",
                "Selecione SSL/TLS (porta 465) ou STARTTLS (porta 587) conforme o provedor.",
                "Clique em \"Testar Conexão\" para validar antes de salvar.",
                "Salve as configurações.",
              ],
            },
            sendTest: {
              description: "Envia um e-mail de teste com os dados configurados acima para validar o fluxo completo.",
              steps: [
                "Salve as configurações SMTP primeiro.",
                "Digite um e-mail de destino válido.",
                "Clique em \"Enviar Teste\" — o e-mail chega em alguns segundos.",
                "Verifique a caixa de entrada (e a pasta de spam) para confirmar.",
              ],
            },
          },
        },
        meta: {
          copy: "Copiar",
          copied: "Copiado!",
          credentials: {
            title: "Credenciais do App Meta",
            description: "Conecte seu App criado no Meta for Developers para integrar Facebook Messenger e Instagram Direct.",
            appIdLabel: "Facebook App ID",
            appIdPlaceholder: "Ex.: 123456789012345",
            appIdHelper: "Encontre em developers.facebook.com › App › Configurações › Básico.",
            appSecretLabel: "Facebook App Secret",
            appSecretPlaceholder: "Ex.: abc123def456...",
            appSecretHelper: "Chave secreta do App. Nunca compartilhe nem versione.",
          },
          webhook: {
            title: "Configuração do Webhook",
            description: "Use estes valores ao registrar o webhook no painel da Meta para que mensagens cheguem ao sistema.",
            verifyTokenLabel: "Token de Verificação",
            verifyTokenHelper: "Gerado automaticamente. Cole no campo \"Token de verificação\" do webhook na Meta.",
            callbackUrlLabel: "URL de Callback",
            callbackUrlHelper: "Cole no campo \"URL de callback\" do webhook na Meta for Developers.",
          },
          fieldHelps: {
            wabaFacebookAppId: "ID numérico do App Meta usado no cadastro incorporado do WhatsApp API Oficial.",
            wabaFacebookAppSecret: "Chave secreta do App Meta usado no WhatsApp API Oficial. Nunca compartilhe esse valor.",
            wabaFacebookConfigId: "ID da configuração do Facebook Login for Business usada para abrir o cadastro incorporado do WhatsApp.",
            wabaWhatsappBusinessToken: "Token permanente do usuário do sistema com permissões para gerenciar e enviar mensagens pela WhatsApp Cloud API.",
            socialFacebookAppId: "ID numérico do App Meta usado para Facebook Messenger e Instagram Direct.",
            socialFacebookAppSecret: "Chave secreta do App Meta usado para Facebook Messenger e Instagram Direct. Nunca compartilhe esse valor.",
            facebookVerifyToken: "Token gerado pelo sistema para a Meta confirmar que o webhook pertence a esta instalação.",
            webhookUrl: "URL que deve ser cadastrada no webhook do App Meta de Facebook/Instagram.",
            wabaWebhookUrl: "URL que deve ser cadastrada no webhook do produto WhatsApp do App Meta.",
            wabaVerifyToken: "Token gerado pelo sistema para validar o webhook do produto WhatsApp na Meta.",
          },
          helps: {
            credentials: {
              description: "Credenciais do seu App no Meta for Developers — necessárias para que mensagens do Messenger e Instagram cheguem na plataforma.",
              steps: [
                "Acesse developers.facebook.com e crie um App tipo \"Empresa\".",
                "No App, abra Configurações › Básico — copie App ID e App Secret.",
                "Cole os valores aqui — salvam automaticamente ao sair do campo.",
                "Adicione os produtos \"Messenger\" e \"Instagram Graph API\" ao App.",
              ],
            },
            webhook: {
              description: "Webhook que a Meta usa para enviar mensagens dos seus canais ao sistema.",
              steps: [
                "No App da Meta, abra Messenger › Configurações › Webhooks (idem para Instagram).",
                "Clique em \"Adicionar URL de callback\".",
                "Copie aqui a URL de Callback e cole no campo correspondente.",
                "Copie o Token de Verificação daqui e cole no campo \"Token\" da Meta.",
                "Confirme — a Meta validará o webhook automaticamente.",
              ],
            },
          },
        },
        settingsConfig: {
          userCreation: {
            name: "Criação de usuário",
            options: {
              enabled: "Ativado",
              disabled: "Desativado",
            },
          },
          options: {
            disabled: "Desabilitado",
            enabled: "Habilitado",
            updating: "Atualizando...",
            systemCurrency: "Moeda do sistema",
            currencyUpdated: "Moeda atualizada com sucesso",
            currencyHelper: "Define a moeda exibida nos cards do Kanban e em todos os campos de valor do sistema. A mudança é sincronizada em tempo real para todos os usuários da empresa.",
            creationCompanyUser: "Criação de Company/Usuário",
            evaluations: "Avaliações",
            officeScheduling: "Controle de Expediente",
            queueManagement: "Gerenciamento por Fila",
            companyManagement: "Gerenciamento por Empresa",
            connectionManagement: "Gerenciamento por Conexão",
            sendGreetingAccepted: "Enviar saudação ao aceitar o ticket",
            sendMsgTransfTicket:
              "Enviar mensagem transferência de setor/atendente",
            checkMsgIsGroup: "Ignorar Mensagens de Grupos",
            chatBotType: "Tipo do Bot",
            userRandom: "Escolher atendente aleatório",
            buttons: "Botões",
            acceptCallWhatsapp: "Aceita ligação no whatsapp?",
            sendSignMessage: "Permite atendente escolher ENVIAR Assinatura",
            sendGreetingMessageOneQueues:
              "Enviar saudação quando houver somente 1 fila",
            sendQueuePosition: "Enviar mensagem com a posição da fila",
            sendFarewellWaitingTicket:
              "Ao fechar ticket em Aguardando, enviar despedida",
            acceptAudioMessageContact:
              "Aceita receber audio de todos contatos?",
            enableLGPD: "Habilitar tratamento LGPD",
            requiredTag: "Tag obrigatoria para fechar ticket",
            closeTicketOnTransfer: "Fechar ticket ao transferir para outra fila",
            DirectTicketsToWallets: "Mover automaticamente cliente para carteira",
            showNotificationPending: "Mostrar notificação para tickets pendentes",
            autoTranslate: "Tradução Automática de Mensagens",
            translateApiKey: "API Key OpenAI (para tradução)",
            translateApiKeyHelper: "Chave da API OpenAI para tradução automática. Se vazio, usa a chave do primeiro Prompt configurado.",
            aiAutoSummary: "Resumo IA Diário Automático",
            aiSummaryApiKey: "API Key OpenAI (para resumo IA)",
            aiSummaryApiKeyHelper: "Chave usada somente para resumos IA. Se vazio, usa a chave de tradução ou a chave do primeiro Prompt configurado.",
            aiAutoSummaryTime: "Horário do Resumo IA Diário",
            aiAutoSummaryTimeHelper: "Horário em que o resumo automático será gerado para todos os tickets abertos.",
            flowbuilderAISectionTitle: "Saída IA do FlowBuilder",
            flowbuilderAISectionDescription: "Quando ativado, a \"Saída IA\" nos blocos do FlowBuilder usa GPT para ler o histórico da conversa e assumir o atendimento automaticamente quando o tempo expira.",
            flowbuilderAI: "Ativar Saída IA no FlowBuilder",
            flowbuilderAIApiKey: "API Key OpenAI (Saída IA)",
            flowbuilderAIApiKeyHelper: "Chave da API OpenAI usada pela Saída IA dos blocos do FlowBuilder.",
            sendWelcomeMessage: "Mensagem de boas-vindas no cadastro",
            welcomeMessageTemplate: "Modelo da mensagem de boas-vindas",
            welcomeMessageHelper: "Use variáveis: {name}, {companyName}, {email}, {phone}, {trialDate}. Se vazio, usa o modelo padrão.",
          },
          customMessages: {
            sendQueuePositionMessage: "Mensagem de posição na fila",
            AcceptCallWhatsappMessage: "Mensagem para informar que não aceita ligações",
            greetingAcceptedMessage: "Mensagem de Saudação ao aceitar ticket",
            transferMessage: "Mensagem de transferência - ${queue.name} = fila destino",
          },
          LGPD: {
            title: "LGPD",
            welcome: "Mensagem de boas-vindas (LGPD)",
            linkLGPD: "Link da política de privacidade",
            obfuscateMessageDelete: "Ofuscar mensagem apagada",
            alwaysConsent: "Sempre solicitar consentimento",
            obfuscatePhoneUser: "Ofuscar número de telefone para usuários",
            enabled: "Habilitado",
            disabled: "Desabilitado",
          },
        },
        toasts: {
          schedulesSavedSuccess: "Horários atualizados com sucesso.",
          operationUpdatedSuccess: "Operação atualizada com sucesso.",
          recordsLoadError: "Não foi possível carregar a lista de registros",
          operationSuccess: "Operação realizada com sucesso!",
          operationError: "Não foi possível realizar a operação. Verifique se já existe um registro com o mesmo nome ou se os campos foram preenchidos corretamente",
          operationDeleteError: "Não foi possível realizar a operação",
          imageUploadProgress: "A imagem está {{progress}}% carregada...",
          imageUploadError: "Houve um problema ao realizar o upload da imagem.",
          companyOperationError: "Não foi possível realizar a operação. Verifique se já existe uma empresa com o mesmo nome ou se os campos foram preenchidos corretamente",
          planOperationError: "Não foi possível realizar a operação. Verifique se já existe uma plano com o mesmo nome ou se os campos foram preenchidos corretamente",
          helpOperationError: "Não foi possível realizar a operação. Verifique se já existe uma helpo com o mesmo nome ou se os campos foram preenchidos corretamente",
        },
        whitelabel: {
          subtitle: "Personalize a marca do sistema — cores, nome, logos e favicon — exibidos em toda a aplicação.",
          primaryColorLight: "Cor Primária Modo Claro",
          primaryColorDark: "Cor Primária Modo Escuro",
          sidebarTextColorLight: "Cor dos textos e ícones da sidebar no modo claro",
          sidebarTextColorDark: "Cor dos textos e ícones da sidebar no modo escuro",
          systemName: "Nome do sistema",
          systemNamePlaceholder: "Ex: ChatIA",
          lightLogo: "Logotipo claro",
          darkLogo: "Logotipo escuro",
          sidebarLightLogo: "Logo da sidebar no modo claro",
          sidebarDarkLogo: "Logo da sidebar no modo escuro",
          loginLightLogo: "Logo do login no modo claro",
          loginDarkLogo: "Logo do login no modo escuro",
          sidebarIconLight: "Ícone da sidebar fechada no modo claro",
          sidebarIconDark: "Ícone da sidebar fechada no modo escuro",
          favicon: "Favicon",
          sections: {
            identity: "Identidade Visual",
            identitySubtitle: "Defina cores e nome exibidos para o usuário.",
            logos: "Logos do Sistema",
            logosSubtitle: "Imagens usadas no login, sidebar e abas do navegador.",
          },
          actions: {
            upload: "Enviar imagem",
            replace: "Substituir",
            remove: "Remover",
            pickColor: "Escolher cor",
          },
          languages: {
            title: "Idiomas",
            subtitle: "Defina o idioma padrão da empresa e quais idiomas seus usuários podem escolher.",
            defaultLabel: "Idioma padrão",
            availableLabel: "Idiomas disponíveis",
            defaultBadge: "Padrão",
            selectedCount_one: "{{count}} idioma selecionado",
            selectedCount_other: "{{count}} idiomas selecionados",
          },
          whatsappButton: {
            title: "Botão de WhatsApp",
            subtitle: "Controle o botão de contato mostrado no cadastro e no modo trial.",
            enabledLabel: "Exibir botões",
            enabledTitle: "Botões ativos",
            enabledHint: "Quando desligado, remove o botão das telas públicas e do trial.",
            phoneLabel: "Telefone do WhatsApp",
          },
          previews: {
            light: "Pré-visualização (modo claro)",
            dark: "Pré-visualização (modo escuro)",
            loginLight: "Pré-visualização do login (modo claro)",
            loginDark: "Pré-visualização do login (modo escuro)",
            sidebarIconLight: "Pré-visualização do ícone da sidebar (modo claro)",
            sidebarIconDark: "Pré-visualização do ícone da sidebar (modo escuro)",
            favicon: "Pré-visualização (favicon)",
            empty: "Nenhuma imagem enviada — usando o padrão do sistema.",
          },
          helps: {
            primaryColorLight: {
              description: "Cor de destaque usada quando o sistema está em tema claro (botões, links, ícones primários).",
              steps: [
                "Clique no campo para abrir o seletor de cor.",
                "Use cores com bom contraste sobre fundo branco (escuras o suficiente para texto legível).",
                "A mudança é aplicada imediatamente para todos os usuários.",
                "Cole um HEX válido (ex: #1976d2) se já tiver a cor da marca.",
              ],
            },
            primaryColorDark: {
              description: "Cor de destaque usada quando o sistema está em tema escuro.",
              steps: [
                "Clique no campo para abrir o seletor de cor.",
                "Prefira cores claras o suficiente para contrastar com fundos escuros.",
                "Não precisa ser igual à do modo claro — adapte para legibilidade.",
                "Cole um HEX válido (ex: #4fc3f7) se quiser pular o seletor.",
              ],
            },
            sidebarTextColorLight: {
              description: "Cor única aplicada aos textos e ícones do menu lateral quando o sistema está em modo claro.",
              steps: [
                "Clique no campo para abrir o seletor de cor.",
                "Use uma cor com bom contraste sobre a cor primária clara da sidebar.",
                "A alteração é aplicada imediatamente no menu lateral.",
                "Afeta textos, ícones, divisores e botão de recolher da sidebar no modo claro.",
              ],
            },
            sidebarTextColorDark: {
              description: "Cor única aplicada aos textos e ícones do menu lateral quando o sistema está em modo escuro.",
              steps: [
                "Clique no campo para abrir o seletor de cor.",
                "Use uma cor com bom contraste sobre a cor primária escura da sidebar.",
                "A alteração é aplicada imediatamente no menu lateral.",
                "Afeta textos, ícones, divisores e botão de recolher da sidebar no modo escuro.",
              ],
            },
            systemName: {
              description: "Nome do produto exibido em vários lugares (título da aba, e-mails, login, sidebar).",
              steps: [
                "Use o nome comercial — máximo ~20 caracteres recomendado.",
                "É salvo automaticamente ao sair do campo.",
                "Aparece no <title> da página (aba do navegador).",
                "Deixe em branco para usar \"Multi100\" como padrão.",
              ],
            },
            lightLogo: {
              description: "Logo exibido no topo da sidebar quando o sistema está em tema claro.",
              steps: [
                "Use PNG ou SVG com fundo transparente.",
                "Resolução recomendada: até 400×120 px.",
                "Essa logo não altera a tela de login.",
                "Clique no ícone de remover para voltar à logo padrão.",
              ],
            },
            darkLogo: {
              description: "Logo exibido no topo da sidebar quando o sistema está em tema escuro.",
              steps: [
                "Use uma versão clara do logo, com bom contraste sobre fundo escuro.",
                "PNG ou SVG com fundo transparente.",
                "Resolução recomendada: até 400×120 px.",
                "Essa logo não altera a tela de login.",
              ],
            },
            loginLightLogo: {
              description: "Logo exibida na tela de login, cadastro e recuperação de senha em modo claro.",
              steps: [
                "Use uma versão otimizada para fundo claro.",
                "Essa logo é independente da logo da sidebar.",
                "Se vazio, o sistema usa a logo clara da sidebar como fallback.",
              ],
            },
            loginDarkLogo: {
              description: "Logo exibida na tela de login, cadastro e recuperação de senha em modo escuro.",
              steps: [
                "Use uma versão otimizada para fundo escuro.",
                "Essa logo é independente da logo da sidebar.",
                "Se vazio, o sistema usa a logo escura da sidebar como fallback.",
              ],
            },
            sidebarIconLight: {
              description: "Ícone exibido quando a sidebar está fechada no modo claro.",
              steps: [
                "Use uma imagem quadrada, preferencialmente PNG ou SVG.",
                "Quando o mouse passa por cima, o ícone dá lugar ao botão de abrir a sidebar.",
                "Se vazio, o sistema usa o favicon como fallback.",
              ],
            },
            sidebarIconDark: {
              description: "Ícone exibido quando a sidebar está fechada no modo escuro.",
              steps: [
                "Use uma versão com bom contraste para fundo escuro.",
                "Quando o mouse sai, o botão volta a ser o ícone.",
                "Se vazio, o sistema usa o favicon como fallback.",
              ],
            },
            favicon: {
              description: "Ícone exibido na aba do navegador e em atalhos.",
              steps: [
                "Use PNG ou ICO quadrado (32×32, 48×48 ou 64×64 px).",
                "Mantenha um desenho simples — fica muito pequeno na aba.",
                "Pode demorar alguns minutos para o navegador atualizar (cache).",
                "Force atualização com Ctrl+F5 caso não veja a mudança.",
              ],
            },
            defaultLanguage: {
              description: "Idioma exibido nas telas públicas (login/cadastro) e usado como padrão para todos os usuários da empresa que ainda não escolheram um idioma manualmente.",
              steps: [
                "Selecione o idioma padrão no menu suspenso.",
                "Ao trocar, usuários que ainda usavam o idioma padrão antigo serão migrados automaticamente para o novo.",
                "Usuários que escolheram um idioma manualmente no seletor do topo NÃO são afetados.",
                "O idioma padrão sempre aparece como disponível.",
              ],
            },
            availableLanguages: {
              description: "Idiomas que os usuários podem selecionar no botão de bandeira no topo da tela.",
              steps: [
                "Marque os idiomas que quer disponibilizar para sua equipe.",
                "Desmarcar um idioma o remove imediatamente do seletor de todos os usuários online.",
                "O idioma padrão sempre fica disponível (você não pode desmarcá-lo).",
                "As mudanças refletem em tempo real, sem precisar recarregar.",
              ],
            },
          },
        },
        timezone: {
          companyTimezone: {
            title: "Fuso Horário da Empresa",
            selectLabel: "Selecione o fuso horário",
            customHelperText: "Fuso horário personalizado para esta empresa",
            inheritedHelperText: "Usando o fuso horário padrão do sistema",
          },
          defaultTimezone: {
            title: "Fuso Horário Padrão do Sistema",
            selectLabel: "Selecione o fuso horário padrão",
            helperText: "Este fuso horário será usado por padrão para todas as empresas que não tiverem um fuso horário personalizado",
          },
          buttons: {
            save: "Salvar",
            useDefault: "Usar Padrão",
            saveDefault: "Salvar Padrão",
          },
          preview: {
            currentTime: "Horário Atual",
            defaultTime: "Horário Padrão",
          },
          status: {
            custom: "Personalizado",
            inherited: "Herdado",
          },
          errors: {
            fetchAvailableTimezones: "Erro ao carregar fusos horários disponíveis",
            fetchCompanyTimezone: "Erro ao carregar fuso horário da empresa",
            updateDefaultTimezone: "Erro ao atualizar fuso horário padrão",
            updateCompanyTimezone: "Erro ao atualizar fuso horário da empresa",
          },
          success: {
            defaultTimezoneUpdated: "Fuso horário padrão atualizado com sucesso",
            companyTimezoneUpdated: "Fuso horário da empresa atualizado com sucesso",
            companyTimezoneReset: "Fuso horário da empresa redefinido com sucesso",
          },
          helps: {
            companyTimezone: {
              description: "Define o fuso horário usado em todas as datas e horários da empresa (notificações, agendamentos, relatórios, horário de atendimento).",
              steps: [
                "Selecione o fuso horário desejado no menu suspenso.",
                "Clique em \"Salvar\" para aplicar — afeta toda a empresa.",
                "Clique em \"Usar Padrão\" para voltar ao fuso configurado pelo super admin.",
                "O preview à direita mostra a hora atual no fuso selecionado.",
              ],
            },
            defaultTimezone: {
              description: "Fuso horário usado por padrão para todas as empresas que ainda não definiram um fuso próprio.",
              steps: [
                "Defina aqui o fuso horário global do sistema.",
                "Empresas sem fuso personalizado herdam este valor.",
                "Mudanças aqui afetam apenas empresas que não customizaram o próprio fuso.",
                "Apenas super administradores podem alterar este campo.",
              ],
            },
            companyTimezoneField: {
              description: "Campo onde você escolhe o fuso horário desta empresa.",
              steps: [
                "Pesquise pelo país, cidade ou nome do fuso.",
                "Escolha o fuso onde a operação da empresa atende.",
                "Salve para aplicar em agendamentos, relatórios e horários de atendimento.",
              ],
            },
            defaultTimezoneField: {
              description: "Campo onde o super admin escolhe o fuso padrão do sistema.",
              steps: [
                "Use o fuso da maioria das empresas atendidas.",
                "Empresas sem fuso próprio usarão este valor automaticamente.",
                "Salve para aplicar como padrão global.",
              ],
            },
          },
        },
        chatBotType: {
          text: "Texto",
        },
        modals: {
          deleteTitle: "Exclusão de Registro",
          deleteConfirmation: "Deseja realmente excluir esse registro?",
        },
        managers: {
          common: {
            yes: "Sim",
            no: "Não",
          },
          companies: {
            recurrence: "Recorrência",
          },
          plans: {
            queues: "Filas",
            value: "Valor",
            whatsapp: "Whatsapp",
            facebook: "Facebook",
            instagram: "Instagram",
            internalChat: "Chat Interno",
            externalAPI: "API Externa",
            kanban: "Kanban",
            talkAI: "Prompts",
            officialAPI: "API Oficial",
            integrations: "Integrações",
          },
          helps: {
            title: "Título",
            video: "Video",
          },
        },
      },
      messagesList: {
        header: {
          assignedTo: "Atribuído à:",
          draft: "Rascunho:",
          you: "Você",
          contact: "Contato",
          document: "Documento",
          photo: "Foto",
          image: "Imagem",
          video: "Vídeo",
          group: "Grupo",
          options: "Opções",
          aiSummaries: "Resumos IA",
          chatbotActive: "Chatbot ativo",
          chatbotInactive: "Chatbot inativo",
          enableChatbot: "Ativar Chatbot",
          disableChatbot: "Desativar Chatbot",
          months: "jan,fev,mar,abr,mai,jun,jul,ago,set,out,nov,dez",
          dateOf: "de",
          dialogRatingTitle:
            "Deseja deixar uma avaliação de atendimento para o cliente?",
          dialogClosingTitle: "Finalizando o atendimento com o cliente!",
          dialogRatingCancel: "Resolver COM Mensagem de Despedida",
          dialogRatingSuccess: "Resolver e Enviar Avaliação",
          dialogRatingWithoutFarewellMsg: "Resolver SEM Mensagem de Despedida",
          ratingTitle: "Escolha um menu de avaliação",
          notMessage: "Nenhuma mensagem selecionada",
          amount: "Valor de prospecção",
          buttons: {
            return: "Retornar",
            resolve: "Resolver",
            reopen: "Reabrir",
            accept: "Aceitar",
            rating: "Enviar Avaliação",
            enableIntegration: "Habilitar integração",
            disableIntegration: "Desabilitar integração",
            logTicket: "Logs do Ticket",
            requiredTag: "Você deve atribuir uma tag antes de fechar o ticket.",
            enableTranslate: "Ativar tradução automática para este contato",
            disableTranslate: "Desativar tradução automática para este contato",
            translateEnabled: "Tradução ativada",
            translateDisabled: "Tradução desativada",
            kanban: "Kanban",
            tags: "Tags",
            aiSummaries: "Resumos IA",
            options: "Opções",
            chatbotActive: "Chatbot ativo",
            chatbotInactive: "Chatbot inativo",
            enableChatbot: "Ativar Chatbot",
            disableChatbot: "Desativar Chatbot",
          },
        },
      },
      messagesInput: {
        placeholderPrivateMessage:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderOpen:
          "Digite uma mensagem ou aperte / para respostas rápidas",
        placeholderClosed:
          "Reabra ou aceite esse ticket para enviar uma mensagem.",
        signMessage: "Assinar",
        privateMessage: "Mensagem Privada",
        translateTooltip: "Sua mensagem será traduzida para",
        you: "Você",
        contact: "Contato",
        videoFallback: "Vídeo",
        format: {
          bold: "Negrito",
          italic: "Itálico",
          strikethrough: "Tachado",
          code: "Código",
          numberedList: "Lista numerada",
          bulletList: "Lista de marcadores",
          quote: "Citação",
        },
        aiSuggestion: {
          tooltip: "Sugestão IA",
          configTitle: "Configurar Sugestões IA",
          promptLabel: "Prompt personalizado",
          promptPlaceholder: "Ex: Você é um agente de vendas especializado em software. Sempre sugira agendar uma demonstração...",
          promptHelper: "Instrua a IA sobre como gerar sugestões. Ex: perfil do agente, tom, produtos, regras de negócio.",
          save: "Salvar",
          saving: "Salvando...",
        },
        quickReplies: {
          header: "Respostas rápidas",
          searchPlaceholder: "Buscar por atalho ou mensagem...",
          empty: "Nenhuma resposta encontrada",
          useReply: "Usar resposta",
        },
      },
      contactDrawer: {
        header: "Dados do contato",
        buttons: {
          edit: "Editar contato",
          block: "Bloquear",
          unblock: "Desbloquear",
          blockContact: "Bloquear contato",
          unblockContact: "Desbloquear contato",
        },
        tabs: {
          data: "Dados",
          followUp: "Follow-up",
          favorites: "Favoritos",
        },
        none: "Nenhum",
        noFavoriteMessages: "Nenhuma mensagem favorita",
        qualification: "Qualificação",
        toasts: {
          contactBlocked: "Contato bloqueado",
          contactUnblocked: "Contato desbloqueado",
        },
        confirmationModal: {
          blockMessage: "Você realmente deseja bloquear esse contato? Você não receberá mais nenhuma mensagem dele.",
          unblockMessage: "Você realmente deseja desbloquear esse contato? Você poderá começar a receber mensagem dele.",
        },
        extraInfo: "Outras informações",
      },
      messageVariablesPicker: {
        label: "Variavéis disponíveis",
        vars: {
          contactFirstName: "Primeiro Nome",
          contactName: "Nome",
          email: "E-mail",
          user: "Atendente",
          greeting: "Saudação",
          protocolNumber: "Protocolo",
          date: "Data",
          hour: "Hora",
          ticket_id: "Nº do Chamado",
          queue: "Setor",
          connection: "Conexão",
        },
        templates: {
          firstName: { label: "Primeiro nome", description: "Primeiro nome do contato" },
          name: { label: "Nome completo", description: "Nome completo do contato" },
          userName: { label: "Atendente", description: "Nome do atendente" },
          ticketId: { label: "ID do Ticket", description: "Número do ticket" },
          greeting: { label: "Saudação", description: "Bom dia / Boa tarde / Boa noite" },
          hour: { label: "Hora", description: "Hora atual" },
          date: { label: "Data", description: "Data atual" },
          dateTime: { label: "Data e hora", description: "Data e hora atual" },
          queue: { label: "Fila", description: "Nome da fila do ticket" },
          connection: { label: "Conexão", description: "Nome da conexão WhatsApp" },
          protocol: { label: "Protocolo", description: "Número de protocolo" },
          companyName: { label: "Empresa", description: "Nome da empresa" },
        },
      },
      ticketOptionsMenu: {
        schedule: "Agendamento",
        delete: "Deletar",
        transfer: "Transferir",
        registerAppointment: "Observações do Contato",
        resolveWithNoFarewell: "Finalizar sem despedida",
        acceptAudioMessage: "Aceitar áudios do contato?",
        appointmentsModal: {
          title: "Follow-up",
          textarea: "Acompanhamento",
          placeholder: "Registre aqui o acompanhamento do contato...",
        },
        confirmationModal: {
          title: "Deletar o ticket do contato",
          titleFrom: "do contato ",
          message:
            "Atenção! Todas as mensagens relacionadas ao ticket serão perdidas.",
        },
        buttons: {
          delete: "Excluir",
          cancel: "Cancelar",
        },
      },
      confirmationModal: {
        buttons: {
          confirm: "Ok",
          cancel: "Cancelar",
        },
      },
      emoji: {
        search: "Pesquisar",
        notfound: "Nenhum emoji encontrado",
        categories: {
          search: "Resultados",
          recent: "Recentes",
          smileys: "Rostos e Emoções",
          people: "Pessoas",
          nature: "Animais e Natureza",
          foods: "Comidas e Bebidas",
          activity: "Atividades",
          places: "Viagens e Lugares",
          objects: "Objetos",
          symbols: "Símbolos",
          flags: "Bandeiras",
          custom: "Personalizados",
        },
      },
      messageInput: {
        variables: "Variáveis",
        aiSuggestions: "Sugestões IA",
        selectLanguage: "Selecione o idioma",
        placeholderCaption: "Adicionar legenda...",
        tooltip: {
          signature: "Habilitar/Desabilitar Assinatura",
          privateMessage: "Habilitar/Desabilitar Mensagem Privada",
          meet: "Enviar link para videoconferencia",
          language: "Idioma do contato — define para qual idioma a mensagem será traduzida",
        },
        type: {
          title: "Anexar",
          imageVideo: "Fotos e vídeos",
          cam: "Câmera",
          contact: "Contato",
          meet: "Vídeo chamada",
        },
      },
      messageOptionsMenu: {
        delete: "Deletar",
        reply: "Responder",
        edit: "Editar",
        forward: "Encaminhar",
        toForward: "Encaminhar",
        talkTo: "Conversar Com",
        react: "Reagir",
        favorite: "Favoritar",
        unfavorite: "Desfavoritar",
        copy: "Copiar",
        erase: "Apagar",
        aiGenerationFailed: "Nenhuma sugestão gerada. Verifique se a API key está configurada.",
        saveToContact: "Salvar no contato",
        confirmationModal: {
          title: "Apagar mensagem?",
          message: "Esta ação não pode ser revertida.",
        },
      },
      invoices: {
        table: {
          invoices: "Faturas",
          details: "Detalhes",
          users: "Usuários",
          connections: "Conexões",
          queue: "Filas",
          value: "Valor",
          expirationDate: "Data Venc.",
          action: "Ação",
        },
      },
      userStatus: {
        online: "Online",
        offline: "Offline",
      },
      backendErrors: {
        ERR_NO_OTHER_WHATSAPP: "Deve haver pelo menos um WhatsApp padrão.",
        ERR_NO_DEF_WAPP_FOUND:
          "Nenhum WhatsApp padrão encontrado. Verifique a página de conexões.",
        ERR_WAPP_NOT_INITIALIZED:
          "Esta sessão do WhatsApp não foi inicializada. Verifique a página de conexões.",
        ERR_WAPP_CHECK_CONTACT:
          "Não foi possível verificar o contato do WhatsApp. Verifique a página de conexões",
        ERR_WAPP_INVALID_CONTACT: "Este não é um número de Whatsapp válido.",
        ERR_WAPP_DOWNLOAD_MEDIA:
          "Não foi possível baixar mídia do WhatsApp. Verifique a página de conexões.",
        ERR_INVALID_CREDENTIALS:
          "Erro de autenticação. Por favor, tente novamente.",
        ERR_SENDING_WAPP_MSG:
          "Erro ao enviar mensagem do WhatsApp. Verifique a página de conexões.",
        ERR_DELETE_WAPP_MSG: "Não foi possível excluir a mensagem do WhatsApp.",
        ERR_OTHER_OPEN_TICKET: "Já existe um tíquete aberto para este contato.",
        ERR_TICKET_ALREADY_ACCEPTED: "Este ticket já foi aceito por outro agente.",
        ERR_SESSION_EXPIRED: "Sessão expirada. Por favor entre.",
        ERR_USER_CREATION_DISABLED:
          "A criação do usuário foi desabilitada pelo administrador.",
        ERR_NO_PERMISSION: "Você não tem permissão para acessar este recurso.",
        ERR_DUPLICATED_CONTACT: "Já existe um contato com este número.",
        ERR_NO_SETTING_FOUND: "Nenhuma configuração encontrada com este ID.",
        ERR_NO_CONTACT_FOUND: "Nenhum contato encontrado com este ID.",
        ERR_NO_TICKET_FOUND: "Nenhum tíquete encontrado com este ID.",
        ERR_NO_USER_FOUND: "Nenhum usuário encontrado com este ID.",
        ERR_NO_WAPP_FOUND: "Nenhum WhatsApp encontrado com este ID.",
        ERR_CREATING_MESSAGE: "Erro ao criar mensagem no banco de dados.",
        ERR_CREATING_TICKET: "Erro ao criar tíquete no banco de dados.",
        ERR_FETCH_WAPP_MSG:
          "Erro ao buscar a mensagem no WhtasApp, talvez ela seja muito antiga.",
        ERR_QUEUE_COLOR_ALREADY_EXISTS:
          "Esta cor já está em uso, escolha outra.",
        ERR_WAPP_GREETING_REQUIRED:
          "A mensagem de saudação é obrigatório quando há mais de uma fila.",
        ERR_OUT_OF_HOURS: "Fora do Horário de Expediente!",
        ERR_USER_EMAIL_ALREADY_EXISTS: "Este email já está em uso. Utilize outro email.",
        ERR_COMPANY_INVALID_NAME: "Nome da organização deve ter pelo menos 2 caracteres.",
        ERR_COMPANY_DUPLICATE_FIELD: "Já existe um cadastro com estes dados.",
        ERR_COMPANY_CREATION_FAILED: "Erro ao criar a empresa. Tente novamente.",
        ERR_GENERIC_ERROR: "Ocorreu um erro!",
      },
      flowBuilderConfig: {
        title: "Desenhe seu fluxo",
        actions: {
          import: "Importar",
          export: "Exportar",
          save: "Salvar"
        },
        messages: {
          flowStart: "Inicio do fluxo",
          interval: "Intervalo {{seconds}} seg.",
          intervalFormatted: "Intervalo {{value}} {{unit}}",
          businessHoursLabel: "Hor. Comercial",
          units: {
            seconds: "seg.",
            minutes: "min.",
            hours: "h",
            days: "dias",
          },
          rememberSave: "Não se esqueça de salvar seu fluxo!",
          flowSaved: "Fluxo salvo com sucesso"
        },
        nodes: {
          start: "Inicio",
          content: "Conteúdo",
          menu: "Menu",
          optionFormat: "[{{number}}] {{value}}",
          randomizer: "Randomizador",
          interval: "Intervalo",
          ticket: "Ticket",
          typebot: "TypeBot",
          openai: "OpenAI",
          question: "Pergunta",
          image: "Imagem",
          video: "Vídeo",
          audioNode: {
            title: "Audio",
            recordedLive: "Gravado na hora",
            audioSent: "Audio enviado",
            browserNotSupported: "seu navegador não suporta HTML5"
          },
          kanbanPhase: "Fase Kanban",
          addTag: "Adicionar Tag",
          noTag: "Nenhuma tag",
          noResponse: "Sem resposta",
        },
        nodeDescriptions: {
          startFlow: "Este bloco marca o inicio do seu fluxo!"
        },
        edges: {
          edgeWithoutOnDelete: "Edge sem onDelete configurado:",
          errorDeletingEdge: "Erro ao deletar edge:",
          removeEdgeTooltip: "Remover conexão"
        },
        units: {
          seconds: "segundos"
        },
        validation: {
          tooShort: "Muito curto!",
          tooLong: "Muito longo!",
          enterName: "Digite um nome!",
          enterMessage: "Digite uma mensagem!",
          required: "Obrigatório",
          describeAiTraining: "Descreva o treinamento para Inteligência Artificial",
          invalidModel: "Modelo inválido",
          informModel: "Informe o modelo",
          minTokens: "Mínimo 10 tokens",
          maxTokens: "Máximo 4096 tokens",
          informMaxTokens: "Informe o número máximo de tokens",
          minZero: "Mínimo 0",
          maxOne: "Máximo 1",
          informTemperature: "Informe a temperatura",
          informApiKey: "Informe a API Key",
          minOneMessage: "Mínimo 1 mensagem",
          maxFiftyMessages: "Máximo 50 mensagens",
          informMaxMessages: "Informe o número máximo de mensagens",
          informVoiceMode: "Informe o modo para Voz"
        },
        buttons: {
          add: "Adicionar",
          save: "Salvar",
          edit: "Editar"
        },
        modals: {
          condition: {
            addTitle: "Adicionar condição ao fluxo",
            editTitle: "Editar condição",
            fieldLabel: "Campo da condição (Digite apenas 1 chave)",
            validationRule: "Regra de validação",
            conditionValue: "Valor da condição a ser analisada"
          },
          ticket: {
            addQueueError: "Adicione uma fila",
            addTitle: "Adicionar uma fila ao fluxo",
            editTitle: "Editar fila",
            selectConnection: "Selecione uma fila"
          },
          randomizer: {
            addIntervalError: "Adicione o valor de intervalo",
            maxTimeError: "Máximo de tempo atingido 120 segundos",
            addTitle: "Adicionar um randomizador ao fluxo",
            editTitle: "Editar randomizador"
          },
          openai: {
            addTitle: "Adicionar OpenAI/Gemini ao fluxo",
            editTitle: "Editar OpenAI/Gemini do fluxo"
          },
          question: {
            addTitle: "Adicionar Pergunta ao fluxo",
            editTitle: "Editar Pergunta",
            createTitle: "Criar Pergunta no fluxo",
            messageLabel: "Mensagem",
            saveAnswer: "Salvar resposta"
          }
        },
        models: {
          "gpt-4.1": "GPT 4.1",
          "gpt-4.1-mini": "GPT 4.1 Mini",
          "gpt-4.1-nano": "GPT 4.1 Nano",
          "gpt-4o": "GPT 4o",
          "gpt-4o-mini": "GPT 4o Mini",
          "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
          "gemini-2.5-pro": "Gemini 2.5 Pro",
          "gemini-2.5-flash": "Gemini 2.5 Flash",
          "gemini-2.0-flash": "Gemini 2.0 Flash",
          "gemini-2.0-pro": "Gemini 2.0 Pro",
        },
        voice: {
          text: "Texto",
          francisca: "Francisca",
          antonio: "Antônio",
          brenda: "Brenda",
          donato: "Donato",
          elza: "Elza",
          fabio: "Fábio",
          giovanna: "Giovanna",
          humberto: "Humberto",
          julio: "Julio",
          leila: "Leila",
          leticia: "Letícia",
          manuela: "Manuela",
          nicolau: "Nicolau",
          valerio: "Valério",
          yara: "Yara"
        }
      },
      flowBuilderModals: {
        textModal: {
          titleAdd: "Adicionar mensagem ao fluxo",
          titleEdit: "Editar mensagem ao fluxo",
          buttonAdd: "Adicionar",
          buttonSave: "Salvar",
          fields: {
            message: "Mensagem"
          },
          validation: {
            tooShort: "Muito curto!",
            tooLong: "Muito longo!",
            required: "Digite um nome!",
            messageRequired: "Digite uma mensagem!"
          }
        },
        intervalModal: {
          titleAdd: "Adicionar um intervalo ao fluxo",
          titleEdit: "Editar intervalo",
          buttonAdd: "Adicionar",
          buttonEdit: "Editar",
          fields: {
            interval: "Intervalo",
            timeInSeconds: "Tempo em segundos",
            timeValue: "Tempo",
            unit: "Unidade",
            unitSeconds: "Segundos",
            unitMinutes: "Minutos",
            unitHours: "Horas",
            unitDays: "Dias",
            businessHours: "Horário comercial",
            businessHoursHelp: "A mensagem será enviada apenas dentro do horário comercial configurado",
            startTime: "Início",
            endTime: "Fim",
            daysOfWeek: "Dias da semana",
            daySun: "Dom",
            dayMon: "Seg",
            dayTue: "Ter",
            dayWed: "Qua",
            dayThu: "Qui",
            dayFri: "Sex",
            daySat: "Sáb",
          },
          validation: {
            addValue: "Adicione o valor de intervalo",
            maxTime: "Valor máximo atingido para esta unidade",
            maxSeconds: "Máximo de 120 segundos",
            maxMinutes: "Máximo de 120 minutos",
            maxHours: "Máximo de 72 horas",
            maxDays: "Máximo de 30 dias",
          },
          aiTimeout: {
            title: "Saída IA (tempo para IA assumir)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, a IA assume o atendimento (saída roxa)"
          }
        },
        typebotModal: {
          titleAdd: "Adicionar Typebot ao fluxo",
          titleEdit: "Editar Typebot",
          buttonAdd: "Adicionar",
          buttonEdit: "Salvar",
          fields: {
            url: "URL do Typebot",
            slug: "Slug do Bot (identificador)",
            expires: "Expiração da sessão (minutos)",
            delay: "Intervalo entre mensagens (ms)",
            keywordFinish: "Palavra para finalizar",
            keywordRestart: "Palavra para reiniciar",
            unknownMessage: "Mensagem de opção inválida",
            restartMessage: "Mensagem ao reiniciar",
          },
          instructions: {
            title: "Como configurar o Typebot (passo a passo)",
            step1: "Tenha uma instância do Typebot rodando (self-hosted ou Typebot Cloud em typebot.io). Anote a URL base, ex: https://typebot.suaempresa.com",
            step2: "No painel do Typebot, crie ou abra o bot que deseja usar. O Slug é o identificador do bot na URL — ex: se a URL do bot é typebot.io/meu-bot, o slug é \"meu-bot\".",
            step3: "No campo \"URL do Typebot\" acima, cole a URL base da sua instância (sem barra no final). No campo \"Slug\", cole o identificador do bot.",
            step4: "Configure a expiração da sessão (em minutos). Após esse tempo sem interação, uma nova conversa será iniciada. Valor 0 = nunca expira.",
            step5: "Opcionalmente, defina palavras-chave para finalizar (ex: \"sair\") ou reiniciar (ex: \"reiniciar\") a conversa com o bot.",
            variablesTitle: "Variáveis disponíveis no Typebot:",
            varNumber: "Número do contato no WhatsApp",
            varPushName: "Nome do contato no WhatsApp",
            varRemoteJid: "ID completo do contato (JID)",
            jsonTitle: "Comandos avançados (JSON):",
            jsonDesc: "No Typebot, envie uma mensagem começando com # para executar ações no ChatIA:",
            jsonStop: "Para o bot e transfere para atendente",
            jsonQueue: "Transfere para a fila ID 1",
            jsonUser: "Transfere para fila 1, atendente 5",
            tip: "Dica: O Typebot suporta textos, imagens, áudios, vídeos e botões de escolha. Todos são enviados automaticamente pelo WhatsApp.",
          },
        },
        menuModal: {
          titleAdd: "Adicionar menu ao fluxo",
          titleEdit: "Editar menu",
          buttonAdd: "Adicionar",
          buttonSave: "Salvar",
          fields: {
            explanationMessage: "Mensagem de explicação do menu",
            addOption: "Adicionar Opção",
            typeOption: "Digite {{number}}",
            optionPlaceholder: "Digite opção"
          },
          invalidOption: {
            title: "Opção inválida",
            messageLabel: "Mensagem para opção inválida",
            placeholder: "Ex: Opção inválida. Por favor, escolha uma das opções abaixo:",
            helperText: "Se preenchido, quando o cliente enviar algo fora das opções, esta mensagem será enviada e o menu será reexibido."
          },
          timeout: {
            title: "Timeout (sem resposta)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, o fluxo segue pelo caminho de timeout (saída laranja)"
          },
          aiTimeout: {
            title: "Saída IA (tempo para IA assumir)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, a IA assume o atendimento (saída roxa)"
          }
        },
        singleBlockModal: {
          titleAdd: "Adicionar conteúdo ao fluxo",
          titleEdit: "Editar conteúdo",
          buttonAdd: "Adicionar",
          buttonSave: "Salvar",
          elements: {
            text: "Texto",
            interval: "Intervalo",
            image: "Imagem",
            audio: "Audio",
            video: "Video",
            document: "Documento"
          },
          fields: {
            message: "Mensagem",
            timeInSeconds: "Tempo em segundos",
            sendAsRecordedAudio: "Enviar como audio gravado na hora",
            noFileSelected: "Nenhum arquivo selecionado"
          },
          buttons: {
            sendImage: "Enviar imagem",
            sendAudio: "Enviar audio",
            sendVideo: "Enviar video",
            sendDocument: "Enviar Documento"
          },
          validation: {
            emptyMessageFields: "Campos de mensagem vazio!",
            intervalValidation: "Intervalo não pode ser 0 ou maior que 120!",
            fileTooLarge2MB: "Arquivo é muito grande! 2MB máximo",
            fileTooLarge5MB: "Arquivo é muito grande! 5MB máximo",
            fileTooLarge20MB: "Arquivo é muito grande! 20MB máximo",
            fileTooLarge15MB: "Arquivo é muito grande! 15MB máximo",
            deleteEmptyCards: "Delete os cards vazios ou envie os arquivos pendentes.",
            browserNotSupported: "seu navegador não suporta HTML5",
            onlyMp4Videos: "ATENÇÃO! Apenas vídeos em MP4!",
            uploadError: "Erro ao processar o arquivo"
          },
          messages: {
            contentAddedSuccess: "Conteúdo adicionada com sucesso!",
            uploadingFiles: "Subindo os arquivos e criando o conteúdo...",
            variables: "Variáveis"
          },
          timeout: {
            title: "Timeout (sem resposta)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, o fluxo segue pelo caminho de timeout (saída amarela)"
          },
          aiTimeout: {
            title: "Saída IA (tempo para IA assumir)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, a IA assume o atendimento (saída roxa)"
          },
          audioRecorder: {
            or: "ou",
            recordAudio: "Gravar áudio",
            recording: "Gravando",
            paused: "Pausado",
            recordingCompleted: "Gravação concluída - {{time}}",
            discard: "Descartar",
            useThisAudio: "Usar este áudio",
            cancel: "Cancelar",
            pause: "Pausar",
            resume: "Continuar",
            finish: "Finalizar",
            pausedHint: "Escute a prévia, continue ou finalize a gravação",
            recordingHint: "Pause ou finalize a gravação",
            microphoneError: "Não foi possível acessar o microfone. Verifique as permissões do navegador."
          }
        },
        randomizerModal: {
          titleAdd: "Adicionar um randomizador ao fluxo",
          titleEdit: "Editar randomizador",
          title: "Distribuição das saídas",
          sliderLabel: "Percentual do randomizador",
          outputsTitle: "Como funciona",
          outputsHint: "O primeiro percentual segue pela primeira saída; o restante segue pela segunda saída.",
          buttonAdd: "Adicionar",
          buttonEdit: "Editar"
        },
        ticketModal: {
          titleAdd: "Adicionar uma fila ao fluxo",
          titleEdit: "Editar fila",
          buttonAdd: "Adicionar",
          buttonEdit: "Editar",
          fields: {
            selectConnection: "Selecione uma Conexão"
          },
          validation: {
            addQueue: "Adicione uma fila"
          }
        },
        openaiModal: {
          titleAdd: "Adicionar OpenAI/Gemini ao fluxo",
          titleEdit: "Editar OpenAI/Gemini do fluxo",
          buttonAdd: "Adicionar",
          buttonSave: "Salvar",
          models: {
            "gpt-4.1": "GPT 4.1",
            "gpt-4.1-mini": "GPT 4.1 Mini",
            "gpt-4.1-nano": "GPT 4.1 Nano",
            "gpt-4o": "GPT 4o",
            "gpt-4o-mini": "GPT 4o Mini",
            "gpt-3.5-turbo-1106": "GPT 3.5 Turbo (legado)",
            "gemini-2.5-pro": "Gemini 2.5 Pro",
            "gemini-2.5-flash": "Gemini 2.5 Flash",
            "gemini-2.0-flash": "Gemini 2.0 Flash",
            "gemini-2.0-pro": "Gemini 2.0 Pro",
          },
          voices: {
            text: "Texto",
            francisca: "Francisca",
            antonio: "Antônio",
            brenda: "Brenda",
            donato: "Donato",
            elza: "Elza",
            fabio: "Fábio",
            giovanna: "Giovanna",
            humberto: "Humberto",
            julio: "Julio",
            leila: "Leila",
            leticia: "Letícia",
            manuela: "Manuela",
            nicolau: "Nicolau",
            valerio: "Valério",
            yara: "Yara"
          },
          validation: {
            tooShort: "Muito curto!",
            tooLong: "Muito longo!",
            required: "Obrigatório",
            promptRequired: "Descreva o treinamento para Inteligência Artificial",
            invalidModel: "Modelo inválido",
            minTokens: "Mínimo 10 tokens",
            maxTokens: "Máximo 4096 tokens",
            tokensRequired: "Informe o número máximo de tokens",
            temperatureRequired: "Informe a temperatura",
            temperatureMin: "Mínimo 0",
            temperatureMax: "Máximo 1",
            apiKeyRequired: "Informe a API Key",
            messagesMin: "Mínimo 1 mensagem",
            messagesMax: "Máximo 50 mensagens",
            messagesRequired: "Informe o número máximo de mensagens",
            voiceRequired: "Informe o modo para Voz"
          },
          instructions: {
            title: "Como configurar a IA OpenAI (passo a passo)",
            step1: "Acesse platform.openai.com e crie uma conta. No menu lateral, vá em \"API Keys\" e clique em \"Create new secret key\". Copie a chave gerada.",
            step2: "Cole a chave no campo \"API Key\" acima. Esta chave é secreta — não compartilhe com ninguém.",
            step3: "No campo \"Prompt\", escreva as instruções de comportamento da IA. Exemplo: \"Você é um atendente virtual da empresa X. Responda de forma educada e objetiva sobre nossos produtos e serviços.\"",
            step4: "Escolha o modelo: GPT-4o Mini é o melhor custo-benefício para atendimento. GPT-4.1 é mais inteligente mas custa mais. GPT-3.5 Turbo é o mais barato.",
            step5: "Temperatura controla a criatividade (0 = respostas exatas, 1 = respostas criativas). Para atendimento, use entre 0.3 e 0.7. Max Tokens limita o tamanho da resposta.",
            promptTipTitle: "Dicas para um bom prompt:",
            promptTip: "Seja específico sobre o papel da IA, o tom de voz, os produtos/serviços da empresa e o que ela NÃO deve fazer. Quanto mais detalhado o prompt, melhores as respostas.",
            tip: "Dica: O campo \"Máx. Mensagens\" define quantas mensagens de contexto a IA lembra. Valores maiores = respostas mais contextuais mas custam mais tokens.",
          },
        },
        geminiModal: {
          instructions: {
            title: "Como configurar a IA Gemini (passo a passo)",
            step1: "Acesse aistudio.google.com e faça login com sua conta Google. Clique em \"Get API Key\" e depois \"Create API key\". Copie a chave gerada.",
            step2: "Cole a chave no campo \"API Key (Google AI)\" acima. Esta chave é secreta — não compartilhe com ninguém.",
            step3: "No campo \"Prompt\", escreva as instruções de comportamento da IA. Exemplo: \"Você é um assistente virtual da empresa X. Responda de forma educada e objetiva.\"",
            step4: "Escolha o modelo: Gemini 2.5 Flash é o melhor custo-benefício. Gemini 2.5 Pro é mais inteligente mas mais lento. Gemini 2.0 Flash é o mais rápido.",
            step5: "Temperatura controla a criatividade (0 = respostas exatas, 1 = respostas criativas). Para atendimento, use entre 0.3 e 0.7.",
            promptTipTitle: "Dicas para um bom prompt:",
            promptTip: "Seja específico sobre o papel da IA, o tom de voz, os produtos/serviços e o que ela NÃO deve fazer. Quanto mais detalhado, melhores as respostas.",
            tip: "Dica: O Gemini do Google tem um plano gratuito generoso. Ideal para começar a testar sem custos.",
          },
        },
        questionModal: {
          titleAdd: "Adicionar Pergunta ao fluxo",
          titleEdit: "Editar Pergunta do fluxo",
          titleCreate: "Criar Pergunta no fluxo",
          buttonAdd: "Adicionar",
          buttonSave: "Salvar",
          fields: {
            message: "Mensagem",
            saveAnswer: "Salvar resposta"
          },
          timeout: {
            title: "Timeout (sem resposta)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, o fluxo segue pelo caminho de timeout (saída amarela)"
          },
          aiTimeout: {
            title: "Saída IA (tempo para IA assumir)",
            label: "Tempo em segundos (0 = desativado)",
            helperText: "Se o cliente não responder em {{seconds}}s, a IA assume o atendimento (saída roxa)"
          }
        }
      },
      moments: {
        title: "Painel em tempo real",
        subtitle: "Atendimentos ao vivo agrupados por atendente",
        pending: "Pendentes",
        attendances: "Atendimentos: ",
        noQueue: "Sem fila",
        accessTicket: "Acessar ticket",
        refresh: "Atualizar",
        empty: "Nenhum atendimento ativo no momento.",
        noTickets: "Nenhum atendimento ativo",
        ticketSingular: "atendimento",
        ticketsPlural: "atendimentos",
        unread: "não lidas",
        kpis: {
          online: "Atendentes online",
          active: "Em atendimento",
          pending: "Aguardando",
          top: "Top atendente",
        },
      },
      flowBuilderNodes: {
        message: "Mensagem",
        condition: "Condição",
        image: "Imagem"
      },
      subscription: {
        title: "Assinatura",
        form: {
          licenseLabel: "Período de Licença",
          licenseExpiresIn: "Sua licença vence em {{days}} dias!",
          licenseExpiresToday: "Sua licença vence hoje!",
          billingEmailLabel: "Email de cobrança",
          subscribeButton: "Assine Agora!"
        },
        checkout: {
          form: {
            fullName: "Nome completo*",
            fullNameRequired: "O nome completo é obrigatório",
            lastName: "Sobrenome*",
            lastNameRequired: "O sobrenome é obrigatório",
            address: "Endereço*",
            addressRequired: "O endereço é obrigatório",
            city: "Cidade*",
            cityRequired: "A cidade é obrigatória",
            state: "Estado*",
            stateRequired: "O estado é obrigatório",
            document: "CPF/CNPJ*",
            documentRequired: "CPF/CNPJ é obrigatório",
            documentInvalid: "Formato de CPF/CNPJ inválido",
            country: "País*",
            countryRequired: "País é obrigatório",
            useAddressForPayment: "Usar este endereço para detalhes de pagamento",
            nameOnCard: "Nome no cartão*",
            nameOnCardRequired: "Nome no cartão é obrigatório",
            cardNumber: "Número do cartão*",
            cardNumberRequired: "Número do cartão é obrigatório",
            cardNumberInvalid: "Número do cartão não é válido (ex: 4111111111111)",
            expiryDate: "Data de expiração*",
            expiryDateRequired: "Data de expiração é obrigatória",
            expiryDateInvalid: "Data de expiração não é válida",
            cvv: "CVV*",
            cvvRequired: "CVV é obrigatório",
            cvvInvalid: "CVV é inválido (ex: 357)"
          }
        }
      },
      ticketsResponsive: {
        actions: {
          selectTicket: "Selecionar Ticket",
          transferTicket: "Transferir Ticket",
          spyConversation: "Espiar Conversa"
        },
        tabs: {
          ticket: "Ticket",
          assistance: "Atendimentos"
        },
        search: {
          searchInMessagesTooltip: "Marque para pesquisar também nos conteúdos das mensagens (mais lento)"
        },
        filter: {
          all: "Todos",
          unreplied: "Não respondidos",
          title: "Filtros",
          queues: "Filas",
          tags: "Tags",
          connections: "Conexões",
          status: "Status",
          users: "Usuários",
          showTags: "Mostrar tags",
          hideTags: "Ocultar tags"
        },
        sort: {
          ascending: "Crescente",
          descending: "Decrescente"
        },
        dialog: {
          spyingConversation: "Espiando a conversa",
          loadingMessages: "Carregando mensagens..."
        },
        status: {
          noQueue: "SEM FILA"
        }
      },
      messagesResponsive: {
        types: {
          location: "Localização",
          contact: "Contato"
        },
        actions: {
          download: "Download",
          dropFileHere: "Solte o arquivo aqui"
        },
        status: {
          forwarded: "Encaminhada",
          deletedByContact: "🚫 Essa mensagem foi apagada pelo contato",
          deletedMessage: "🚫 _Mensagem apagada_",
          deletedByMe: "🚫 Essa mensagem foi apagada",
          edited: "Editada"
        },
        reactions: {
          youReacted: "Você reagiu...",
          contactReacted: " reagiu... "
        },
        timestamp: {
          today: "HOJE",
          yesterday: "ONTEM"
        },
        placeholder: {
          sayHello: "Diga olá para seu novo contato!"
        },
        ads: {
          adClick: "Clique de Anúncio",
          defaultUserMessage: "Olá! Tenho interesse e queria mais informações, por favor."
        },
        warnings: {
          facebookPolicy: "Você tem 24h para responder após receber uma mensagem, de acordo com as políticas do Facebook."
        },
        translation: {
          translatedFrom: "Traduzido de",
          showOriginal: "Ver original",
          showTranslation: "Ver tradução",
          autoTranslated: "Tradução automática enviada",
        },
        transcription: {
          transcribe: "Transcrever áudio",
          transcribing: "Transcrevendo...",
          showOriginal: "Ver original",
          showTranslation: "Ver tradução",
          language: "Idioma",
        }
      },
      messageInputResponsive: {
        type: {
          document: "Documento",
          buttons: "Botões"
        },
        tooltip: {
          toggleSignature: "Habilitar/Desabilitar Assinatura",
          toggleComments: "Habilitar/Desabilitar Comentários"
        },
        privateMessage: {
          suffix: "Mensagem Privada"
        }
      },
      tagsResponsive: {
        validation: {
          tooShort: "Tag muito curta!"
        },
        placeholder: "Tags"
      },
      showTicketOpenModal: {
        buttons: {
          close: "Fechar"
        }
      },
      reactions: {
        successMessage: "Reação enviada com sucesso"
      },
      vcardPreview: {
        chatButton: "Conversar"
      },
      locationPreview: {
        viewButton: "Visualizar"
      },
      contactNotes: {
        addedSuccess: "Follow-up adicionado com sucesso!",
        deletedSuccess: "Follow-up excluído com sucesso!",
        deleteTitle: "Excluir follow-up",
        deleteConfirmation: "Deseja realmente excluir este follow-up?",
        cancelButton: "Cancelar",
        saveButton: "Salvar"
      },
      validationResponsive: {
        ratingRequired: "Avaliação obrigatória"
      }
    },
  },
};

export { messages };
